var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferAFriendGraphic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Floor_00000138534621821942084580000000170930492156592565_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M87.525,455.094 c-89.731-51.806-89.731-135.801,0-187.607c89.731-51.806,235.215-51.806,324.948,0c89.733,51.806,89.733,135.801,0,187.607 C322.74,506.9,177.256,506.9,87.525,455.094z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadows"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow_00000116233092986103368180000002252672280941636736_",
    style: {
      fill: "#E0E0E0"
    },
    cx: 147.311,
    cy: 442.543,
    rx: 32.07,
    ry: 18.516
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow_00000164478738526256774020000012495105484486881960_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M188.083,472.448 c-1.452,0.839-3.806,0.839-5.259,0l-29.633-17.125c-1.452-0.838-1.452-2.198,0-3.036l141.556-81.749 c1.452-0.838,3.806-0.838,5.259,0l29.634,17.126c1.452,0.838,1.457,2.207,0.012,3.057L188.083,472.448z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Conection_Icon",
    style: {
      fill: "#E0E0E0"
    },
    d: "M462.916,197.205c-1.591-2.211-3.52-3.43-5.241-3.546l-8.686-27.184 c0.523-0.275,0.995-0.689,1.387-1.262c1.927-2.82,1.232-8.24-1.551-12.107c-2.783-3.867-6.601-4.716-8.528-1.896 s-1.233,8.24,1.551,12.107c1.591,2.211,3.52,3.43,5.241,3.546l8.686,27.184c-0.523,0.275-0.995,0.689-1.387,1.262 c-0.391,0.573-0.669,1.257-0.849,2.009l-19.282-11.676c-0.126-2.45-1.031-5.168-2.622-7.379c-2.783-3.867-6.601-4.716-8.528-1.896 c-1.927,2.82-1.232,8.24,1.551,12.107c2.783,3.867,6.601,4.716,8.527,1.896c0.391-0.573,0.669-1.257,0.849-2.009l19.282,11.676 c0.126,2.45,1.031,5.168,2.622,7.379c2.783,3.867,6.601,4.716,8.528,1.896C466.394,206.492,465.699,201.072,462.916,197.205z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Conection_Icon_00000132801648470158678870000009916785439869893805_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M46.719,387.426 c1.301-1.855,2.877-2.878,4.284-2.976l7.1-22.809c-0.428-0.231-0.814-0.578-1.133-1.059c-1.575-2.366-1.008-6.914,1.267-10.159 c2.275-3.245,5.396-3.957,6.971-1.591c1.575,2.366,1.007,6.914-1.268,10.159c-1.301,1.855-2.877,2.878-4.284,2.975l-7.1,22.809 c0.427,0.231,0.813,0.578,1.133,1.059c0.32,0.481,0.547,1.055,0.694,1.686l15.763-9.797c0.103-2.056,0.843-4.336,2.144-6.191 c2.275-3.245,5.396-3.957,6.971-1.591c1.575,2.366,1.007,6.914-1.268,10.159c-2.275,3.245-5.396,3.957-6.971,1.591 c-0.32-0.481-0.547-1.055-0.694-1.686l-15.763,9.797c-0.103,2.056-0.843,4.336-2.144,6.191c-2.275,3.244-5.396,3.957-6.971,1.591 C43.876,395.219,44.444,390.671,46.719,387.426z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Friend_00000051380281097992366090000002476690127731206800_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M332.353,61.234 c3.597,2.077,6.513-0.128,6.513-4.924c0-4.796-2.917-10.368-6.513-12.444c-3.597-2.077-6.513,0.127-6.513,4.924 C325.839,53.585,328.755,59.157,332.353,61.234z M343.653,78.694c-0.66-4.505-3.392-9.03-6.555-10.856l-9.491-5.48 c-3.162-1.826-5.893-0.456-6.554,3.286l-1.163,6.591c-0.23,1.306,0.592,3.137,1.696,3.774l21.533,12.432 c1.103,0.637,1.926-0.244,1.696-1.815L343.653,78.694z M348.16,65.592c2.584,1.492,4.68-0.092,4.68-3.539 c0-3.446-2.096-7.45-4.68-8.942c-2.586-1.493-4.68,0.092-4.68,3.539C343.479,60.096,345.574,64.099,348.16,65.592z M356.957,82.814 l-0.673-5.485c-0.483-3.213-2.442-6.472-4.715-7.784l-6.82-3.937c-1.935-1.117-3.627-0.579-4.377,1.245 c3.314,2.816,5.405,7.331,6.421,12.27l8.942,5.145C357.042,85.021,357.223,84.676,356.957,82.814z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Friend",
    style: {
      fill: "#E0E0E0"
    },
    d: "M437.443,382.008c3.597-2.077,6.513-7.648,6.513-12.444 c0-4.796-2.916-7.001-6.513-4.924c-3.597,2.077-6.514,7.648-6.514,12.444C430.929,381.881,433.846,384.085,437.443,382.008z  M421.635,386.367c2.585-1.493,4.68-5.496,4.68-8.942c0-3.447-2.095-5.032-4.68-3.539c-2.584,1.492-4.68,5.496-4.68,8.942 C416.956,386.275,419.051,387.858,421.635,386.367z M449.905,393.009l-1.163-6.591c-0.66-3.742-3.392-5.111-6.554-3.286 l-9.491,5.48c-3.163,1.826-5.895,6.351-6.555,10.856l-1.162,7.931c-0.23,1.572,0.592,2.452,1.696,1.816l21.533-12.432 C449.313,396.146,450.135,394.315,449.905,393.009z M429.422,387.627c-0.75-1.824-2.442-2.362-4.377-1.245l-6.82,3.938 c-2.273,1.312-4.232,4.571-4.715,7.784l-0.673,5.485c-0.266,1.862-0.085,2.207,1.221,1.453l8.942-5.145 C424.017,394.957,426.109,390.443,429.422,387.627z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Heart",
    style: {
      fill: "#E0E0E0"
    },
    d: "M83.821,209.401l0.002-0.001l-0.003,0.001L83.821,209.401z M89.99,191.383 c-0.61-1.534-1.783-2.74-3.304-3.395c-1.52-0.656-3.202-0.681-4.735-0.07c-2.351,0.934-3.608,3.497-3.81,5.622l-0.138,1.447 l-1.093-0.957c-1.106-0.969-2.827-1.868-4.639-1.868c-0.625,0-1.262,0.107-1.887,0.356c-1.535,0.609-2.74,1.782-3.396,3.303 c-0.655,1.521-0.681,3.203-0.071,4.738c2.41,6.058,10.097,7.535,12.991,8.091l3.885,0.746l2.309-3.208 C87.826,203.793,92.4,197.441,89.99,191.383z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plant_00000178924202921753767000000013153231571090306485_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plant_00000168800364849287849800000013534137428363465909_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pot_00000080910920232008175110000003003915662160941990_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M131.493,443.86c-8.461-8.731-13.431-31.412-5.178-38.337h41.991 c8.251,6.923,3.286,29.592-5.17,38.329c-0.072,0.081-0.156,0.16-0.232,0.24c-0.097,0.097-0.194,0.195-0.291,0.288 c-0.239,0.234-0.492,0.463-0.765,0.688c-0.067,0.056-0.135,0.106-0.202,0.161c-0.207,0.164-0.412,0.329-0.638,0.488 c-0.361,0.259-0.725,0.5-1.094,0.707c-6.96,4.064-18.245,4.064-25.204,0l-0.001,0l-0.001,0 c-0.372-0.209-0.738-0.451-1.101-0.712c-0.211-0.147-0.4-0.301-0.595-0.454c-0.083-0.067-0.167-0.129-0.25-0.198 c-0.263-0.217-0.507-0.438-0.738-0.664c-0.113-0.108-0.225-0.221-0.336-0.333C131.624,443.995,131.554,443.929,131.493,443.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M164.66,402.734c9.581,5.594,9.581,14.664,0,20.257c-9.581,5.594-25.116,5.594-34.697,0 c-9.581-5.594-9.581-14.663,0.001-20.257C139.545,397.14,155.079,397.14,164.66,402.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M160.051,405.425c7.036,4.108,7.036,10.768,0,14.876c-7.036,4.108-18.444,4.108-25.48,0 c-7.036-4.108-7.036-10.768,0-14.877C141.608,401.317,153.016,401.317,160.051,405.425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M134.572,412.485c7.036-4.108,18.444-4.108,25.48,0c1.955,1.141,3.345,2.483,4.215,3.908 c-0.869,1.426-2.26,2.767-4.215,3.908c-7.036,4.108-18.444,4.108-25.48,0c-1.955-1.141-3.346-2.482-4.215-3.908 C131.225,414.967,132.617,413.626,134.572,412.485z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M144.487,356.486c-3.218,3.487-12.162,4.447-15.865-4.975 c-3.473-8.837-7.222-17.212-8.291-20.456c-1.069-3.244,2.138-4.313,2.138-4.313s0.255-4.854,8.483-1.565 c8.144,3.255,14.032,8.283,17.618,16.357C152.106,349.494,149.994,355.401,144.487,356.486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "#FFFFFF"
    },
    d: "M144.487,356.486c-3.218,3.487-12.162,4.447-15.865-4.975 c-3.473-8.837-7.222-17.212-8.291-20.456c-1.069-3.244,2.138-4.313,2.138-4.313s0.255-4.854,8.483-1.565 c8.144,3.255,14.032,8.283,17.618,16.357C152.106,349.494,149.994,355.401,144.487,356.486z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M148.048,368.942c-0.155-1.648-0.374-3.293-0.713-4.914c-0.675-3.225-1.595-6.386-2.729-9.479 c-2.309-6.301-5.531-12.213-9.535-17.599c-2.251-3.028-4.711-5.944-7.493-8.5c-0.084-0.078-0.15,0.111-0.093,0.171 c4.583,4.932,8.61,10.233,11.736,16.213c3.042,5.818,5.345,11.981,6.789,18.388c0.404,1.79,0.789,3.589,1.118,5.394 c0.335,1.835,0.525,3.689,0.834,5.526c0.031,0.184,0.315,0.296,0.331,0.046C148.397,372.448,148.21,370.675,148.048,368.942z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M148.048,368.942c-0.155-1.648-0.374-3.293-0.713-4.914c-0.675-3.225-1.595-6.386-2.729-9.479 c-2.309-6.301-5.531-12.213-9.535-17.599c-2.251-3.028-4.711-5.944-7.493-8.5c-0.084-0.078-0.15,0.111-0.093,0.171 c4.583,4.932,8.61,10.233,11.736,16.213c3.042,5.818,5.345,11.981,6.789,18.388c0.404,1.79,0.789,3.589,1.118,5.394 c0.335,1.835,0.525,3.689,0.834,5.526c0.031,0.184,0.315,0.296,0.331,0.046C148.397,372.448,148.21,370.675,148.048,368.942z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M150.797,354.043c-7.389,2.285-12.879-3.482-10.979-12.527 c1.9-9.045,11.401-19.085,14.99-16.388c2.24-2.24,7.178-1.436,9.501,5.909C166.632,338.382,164.52,357.248,150.797,354.043z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "#FFFFFF"
    },
    d: "M150.797,354.043c-7.389,2.285-12.879-3.482-10.979-12.527 c1.9-9.045,11.401-19.085,14.99-16.388c2.24-2.24,7.178-1.436,9.501,5.909C166.632,338.382,164.52,357.248,150.797,354.043z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M155.131,330.631c-2.199,5.193-3.638,10.767-4.912,16.25 c-1.303,5.607-2.167,11.305-2.853,17.017c-1.326,11.052-1.552,22.228-1.481,33.348c0.02,3.077,0.064,6.154,0.123,9.23 c0.06,3.164,0.009,6.37,0.281,9.523c0.104,1.209,1.824,0.887,1.845-0.221c0.109-5.539-0.195-11.102-0.251-16.644 c-0.056-5.477-0.037-10.957,0.103-16.433c0.284-11.15,1.098-22.304,2.991-33.305c0.527-3.066,1.112-6.127,1.827-9.155 c0.752-3.187,1.674-6.326,2.511-9.49C155.348,330.626,155.204,330.46,155.131,330.631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M155.131,330.631c-2.199,5.193-3.638,10.767-4.912,16.25c-1.303,5.607-2.167,11.305-2.853,17.017 c-1.326,11.052-1.552,22.228-1.481,33.348c0.02,3.077,0.064,6.154,0.123,9.23c0.06,3.164,0.009,6.37,0.281,9.523 c0.104,1.209,1.824,0.887,1.845-0.221c0.109-5.539-0.195-11.102-0.251-16.644c-0.056-5.477-0.037-10.957,0.103-16.433 c0.284-11.15,1.098-22.304,2.991-33.305c0.527-3.066,1.112-6.127,1.827-9.155c0.752-3.187,1.674-6.326,2.511-9.49 C155.348,330.626,155.204,330.46,155.131,330.631z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M138.772,380.567c-3.229,3.655-10.627,3.332-15.588-3.19c-4.961-6.522-7.941-31.043-0.959-29.48 c1.479-3.274,20.773,4.586,23.249,20.589C147.274,380.118,138.772,380.567,138.772,380.567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "#FFFFFF"
    },
    d: "M138.772,380.567c-3.229,3.655-10.627,3.332-15.588-3.19 c-4.961-6.522-7.941-31.043-0.959-29.48c1.479-3.274,20.773,4.586,23.249,20.589 C147.274,380.118,138.772,380.567,138.772,380.567z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M144.543,392.155c-0.201-1.517-0.555-2.996-0.952-4.472c-0.807-3.006-1.767-5.962-2.871-8.872 c-2.256-5.95-5.215-11.553-8.622-16.919c-1.886-2.971-3.866-5.938-6.119-8.646c-0.062-0.075-0.12,0.095-0.085,0.147 c1.724,2.513,3.47,4.996,5.022,7.623c1.607,2.72,3.047,5.544,4.374,8.41c2.555,5.518,4.7,11.223,6.364,17.072 c0.473,1.661,0.862,3.344,1.352,5c0.509,1.719,1.151,3.405,1.583,5.145c0.063,0.253,0.386,0.345,0.353,0.011 C144.794,395.156,144.741,393.652,144.543,392.155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M144.543,392.155c-0.201-1.517-0.555-2.996-0.952-4.472c-0.807-3.006-1.767-5.962-2.871-8.872 c-2.256-5.95-5.215-11.553-8.622-16.919c-1.886-2.971-3.866-5.938-6.119-8.646c-0.062-0.075-0.12,0.095-0.085,0.147 c1.724,2.513,3.47,4.996,5.022,7.623c1.607,2.72,3.047,5.544,4.374,8.41c2.555,5.518,4.7,11.223,6.364,17.072 c0.473,1.661,0.862,3.344,1.352,5c0.509,1.719,1.151,3.405,1.583,5.145c0.063,0.253,0.386,0.345,0.353,0.011 C144.794,395.156,144.741,393.652,144.543,392.155z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M150.586,376.943c-4.223-0.962-4.434-6.035,0.844-12.26s18.579-8.939,19.213-6.315 c2.956,0,2.956,9.259-3.589,17.764C160.509,384.638,150.982,382.66,150.586,376.943z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "#FFFFFF"
    },
    d: "M150.586,376.943c-4.223-0.962-4.434-6.035,0.844-12.26s18.579-8.939,19.213-6.315 c2.956,0,2.956,9.259-3.589,17.764C160.509,384.638,150.982,382.66,150.586,376.943z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M158.86,367.891c-2.772,1.984-5.218,4.236-7.31,6.941c-2.078,2.686-3.707,5.664-4.914,8.837 c-0.138,0.362,0.488,0.891,0.637,0.498c2.354-6.217,6.443-11.991,11.611-16.19C158.915,367.95,158.913,367.853,158.86,367.891z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M158.86,367.891c-2.772,1.984-5.218,4.236-7.31,6.941c-2.078,2.686-3.707,5.664-4.914,8.837 c-0.138,0.362,0.488,0.891,0.637,0.498c2.354-6.217,6.443-11.991,11.611-16.19C158.915,367.95,158.913,367.853,158.86,367.891z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M155.411,407.842c-5.85,2.368-3.343,9.333,2.368,14.626c5.711,5.293,13.876,6.686,17.803,6.407 c3.927-0.279,4.932-0.817,4.932-0.817s0.626-6.022-0.03-9.682c-0.923-5.148-4.691-12.386-13.788-14.852 C157.598,401.058,155.411,404.359,155.411,407.842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "#FFFFFF"
    },
    d: "M155.411,407.842c-5.85,2.368-3.343,9.333,2.368,14.626 c5.711,5.293,13.876,6.686,17.803,6.407c3.927-0.279,4.932-0.817,4.932-0.817s0.626-6.022-0.03-9.682 c-0.923-5.148-4.691-12.386-13.788-14.852C157.598,401.058,155.411,404.359,155.411,407.842z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M171.606,418.128c-2.711-3.029-5.542-6.039-8.958-8.287c-3.331-2.192-7.772-4.062-11.766-2.696 c-1.548,0.529-3.954,2.072-3.664,3.989c0.029,0.19,0.367,0.663,0.595,0.4c0.716-0.825,1.228-1.782,2.106-2.458 c0.913-0.703,2.006-1.058,3.141-1.191c2.787-0.326,5.75,0.567,8.202,1.866c3.956,2.097,7.148,5.351,10.298,8.47 C171.594,418.255,171.633,418.158,171.606,418.128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M171.606,418.128c-2.711-3.029-5.542-6.039-8.958-8.287c-3.331-2.192-7.772-4.062-11.766-2.696 c-1.548,0.529-3.954,2.072-3.664,3.989c0.029,0.19,0.367,0.663,0.595,0.4c0.716-0.825,1.228-1.782,2.106-2.458 c0.913-0.703,2.006-1.058,3.141-1.191c2.787-0.326,5.75,0.567,8.202,1.866c3.956,2.097,7.148,5.351,10.298,8.47 C171.594,418.255,171.633,418.158,171.606,418.128z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M133.138,377.887c0.554-2.665-3.289-9.043-15.283-10.266 c-11.995-1.223-20.979,3.866-22.791,6.189c-1.812,2.323-2.725,4.771-0.55,5.379c2.175,0.608,9.669,1.339,14.59,3.604 c4.921,2.265,14.92,8.956,21.746,6.966C137.675,387.769,136.531,380.533,133.138,377.887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "#FFFFFF"
    },
    d: "M133.138,377.887c0.554-2.665-3.289-9.043-15.283-10.266 c-11.995-1.223-20.979,3.866-22.791,6.189c-1.812,2.323-2.725,4.771-0.55,5.379c2.175,0.608,9.669,1.339,14.59,3.604 c4.921,2.265,14.92,8.956,21.746,6.966C137.675,387.769,136.531,380.533,133.138,377.887z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M142.255,387.172c-5.059-10.448-18.095-13.637-28.751-13.579 c-3.53,0.019-6.975,0.464-10.392,1.351c-0.047,0.012-0.054,0.13,0.003,0.121c5.715-0.902,11.638-1.106,17.361-0.176 c5.656,0.919,11.212,2.676,15.865,6.117c2.288,1.692,4.23,3.916,5.673,6.364C142.164,387.623,142.358,387.385,142.255,387.172z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M142.255,387.172c-5.059-10.448-18.095-13.637-28.751-13.579 c-3.53,0.019-6.975,0.464-10.392,1.351c-0.047,0.012-0.054,0.13,0.003,0.121c5.715-0.902,11.638-1.106,17.361-0.176 c5.656,0.919,11.212,2.676,15.865,6.117c2.288,1.692,4.23,3.916,5.673,6.364C142.164,387.623,142.358,387.385,142.255,387.172z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M161.079,363.89c-0.154,4.196,5.75,6.63,11.463,3.004s11.703-7.158,16.996-8.526 c5.293-1.368,7.8-5.686,6.129-7.775c-1.672-2.09-4.33-7.362-18.247-5.641c-13.918,1.721-18.847,7.992-20.755,12.42 C154.757,361.799,158.985,365.099,161.079,363.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "#FFFFFF"
    },
    d: "M161.079,363.89c-0.154,4.196,5.75,6.63,11.463,3.004s11.703-7.158,16.996-8.526 c5.293-1.368,7.8-5.686,6.129-7.775c-1.672-2.09-4.33-7.362-18.247-5.641c-13.918,1.721-18.847,7.992-20.755,12.42 C154.757,361.799,158.985,365.099,161.079,363.89z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M183.729,350.574c-1.965-0.309-4.063,0.136-5.968,0.626c-1.756,0.452-3.464,1.068-5.109,1.83 c-3.267,1.514-6.241,3.674-8.702,6.303c-0.7,0.748-1.367,1.533-1.965,2.365c-0.536,0.746-1.188,1.559-1.486,2.434 c-0.094,0.276,0.309,0.725,0.553,0.444c0.689-0.794,1.206-1.766,1.853-2.603c0.695-0.899,1.439-1.757,2.239-2.564 c1.607-1.621,3.415-3.034,5.362-4.224c1.889-1.154,3.86-2.137,5.942-2.892c1.137-0.412,2.29-0.745,3.463-1.039 c1.249-0.313,2.485-0.621,3.784-0.526C183.762,350.734,183.796,350.585,183.729,350.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M183.729,350.574c-1.965-0.309-4.063,0.136-5.968,0.626c-1.756,0.452-3.464,1.068-5.109,1.83 c-3.267,1.514-6.241,3.674-8.702,6.303c-0.7,0.748-1.367,1.533-1.965,2.365c-0.536,0.746-1.188,1.559-1.486,2.434 c-0.094,0.276,0.309,0.725,0.553,0.444c0.689-0.794,1.206-1.766,1.853-2.603c0.695-0.899,1.439-1.757,2.239-2.564 c1.607-1.621,3.415-3.034,5.362-4.224c1.889-1.154,3.86-2.137,5.942-2.892c1.137-0.412,2.29-0.745,3.463-1.039 c1.249-0.313,2.485-0.621,3.784-0.526C183.762,350.734,183.796,350.585,183.729,350.574z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M151.093,386.53c-1.95-1.95-7.243-1.497-9.75,4.266c-2.507,5.763,2.755,12.068,3.343,13.842 c2.419-1.397,4.299-0.564,8.557-1.397c4.258-0.832,8.437-5.321,8.158-10.598C161.122,387.366,158.893,383.883,151.093,386.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "#FFFFFF"
    },
    d: "M151.093,386.53c-1.95-1.95-7.243-1.497-9.75,4.266 c-2.507,5.763,2.755,12.068,3.343,13.842c2.419-1.397,4.299-0.564,8.557-1.397c4.258-0.832,8.437-5.321,8.158-10.598 C161.122,387.366,158.893,383.883,151.093,386.53z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M151.02,385.949c-1.045,0.507-1.939,1.739-2.584,2.674c-0.689,1-1.253,2.092-1.674,3.231 c-0.858,2.322-1.218,4.894-0.737,7.338c0.018,0.093,0.095,0.008,0.091-0.051c-0.16-2.493,0.197-4.97,1.233-7.254 c0.47-1.036,1.061-2.013,1.757-2.913c0.367-0.474,0.757-0.931,1.176-1.359c0.359-0.366,0.848-0.68,1.12-1.116 C151.54,386.279,151.317,385.805,151.02,385.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M151.02,385.949c-1.045,0.507-1.939,1.739-2.584,2.674c-0.689,1-1.253,2.092-1.674,3.231 c-0.858,2.322-1.218,4.894-0.737,7.338c0.018,0.093,0.095,0.008,0.091-0.051c-0.16-2.493,0.197-4.97,1.233-7.254 c0.47-1.036,1.061-2.013,1.757-2.913c0.367-0.474,0.757-0.931,1.176-1.359c0.359-0.366,0.848-0.68,1.12-1.116 C151.54,386.279,151.317,385.805,151.02,385.949z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M141.915,398.208c-0.179-4.29-4.827-7.687-11.441-9.654c-6.615-1.967-13.765-0.307-18.592,4.942 c-4.827,5.248-7.33,9.718-5.363,10.969c1.966,1.251,10.726,4.469,16.447,6.257c5.721,1.788,13.229,2.324,18.95-1.073 C147.636,406.253,147.278,400.353,141.915,398.208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "#FFFFFF"
    },
    d: "M141.915,398.208c-0.179-4.29-4.827-7.687-11.441-9.654 c-6.615-1.967-13.765-0.307-18.592,4.942c-4.827,5.248-7.33,9.718-5.363,10.969c1.966,1.251,10.726,4.469,16.447,6.257 c5.721,1.788,13.229,2.324,18.95-1.073C147.636,406.253,147.278,400.353,141.915,398.208z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M142.283,397.726c-2.123-1.232-4.776-1.674-7.187-1.919c-2.393-0.243-4.811-0.195-7.198,0.087 c-2.524,0.298-5.018,0.857-7.453,1.575c-1.275,0.376-2.537,0.794-3.784,1.253c-1.16,0.427-2.372,0.829-3.46,1.423 c-0.042,0.023-0.067,0.165,0.007,0.15c1.212-0.253,2.397-0.726,3.581-1.09c1.277-0.393,2.559-0.77,3.852-1.106 c2.416-0.629,4.864-1.126,7.348-1.389c2.478-0.262,4.99-0.281,7.465,0.026c2.334,0.29,4.518,1.01,6.766,1.655 C142.681,398.523,142.544,397.877,142.283,397.726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M142.283,397.726c-2.123-1.232-4.776-1.674-7.187-1.919c-2.393-0.243-4.811-0.195-7.198,0.087 c-2.524,0.298-5.018,0.857-7.453,1.575c-1.275,0.376-2.537,0.794-3.784,1.253c-1.16,0.427-2.372,0.829-3.46,1.423 c-0.042,0.023-0.067,0.165,0.007,0.15c1.212-0.253,2.397-0.726,3.581-1.09c1.277-0.393,2.559-0.77,3.852-1.106 c2.416-0.629,4.864-1.126,7.348-1.389c2.478-0.262,4.99-0.281,7.465,0.026c2.334,0.29,4.518,1.01,6.766,1.655 C142.681,398.523,142.544,397.877,142.283,397.726z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M155.563,391.819c-4.728-3.755-3.152-12.764,13.395-13.25 c16.547-0.486,28.366,3.834,27.84,9.159c2.663,2.663,1.313,10.124-12.082,12.453 C171.322,402.51,152.149,401.353,155.563,391.819z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "#FFFFFF"
    },
    d: "M155.563,391.819c-4.728-3.755-3.152-12.764,13.395-13.25 c16.547-0.486,28.366,3.834,27.84,9.159c2.663,2.663,1.313,10.124-12.082,12.453 C171.322,402.51,152.149,401.353,155.563,391.819z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M189.015,387.788c-4.846-0.892-9.867-1.001-14.781-0.862c-4.54,0.128-9.248,0.343-13.647,1.568 c-1.143,0.318-2.258,0.724-3.328,1.237c-0.495,0.237-0.983,0.492-1.452,0.777c-0.375,0.228-0.795,0.427-0.931,0.867 c-0.082,0.267,0.227,0.589,0.493,0.527c1.006-0.235,1.944-1.011,2.894-1.435c0.928-0.414,1.89-0.754,2.864-1.043 c1.876-0.555,3.81-0.89,5.749-1.132c4.62-0.577,9.311-0.832,13.967-0.77c2.721,0.036,5.429,0.242,8.14,0.458 C189.066,387.986,189.098,387.803,189.015,387.788z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M189.015,387.788c-4.846-0.892-9.867-1.001-14.781-0.862c-4.54,0.128-9.248,0.343-13.647,1.568 c-1.143,0.318-2.258,0.724-3.328,1.237c-0.495,0.237-0.983,0.492-1.452,0.777c-0.375,0.228-0.795,0.427-0.931,0.867 c-0.082,0.267,0.227,0.589,0.493,0.527c1.006-0.235,1.944-1.011,2.894-1.435c0.928-0.414,1.89-0.754,2.864-1.043 c1.876-0.555,3.81-0.89,5.749-1.132c4.62-0.577,9.311-0.832,13.967-0.77c2.721,0.036,5.429,0.242,8.14,0.458 C189.066,387.986,189.098,387.803,189.015,387.788z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile_00000098188535446389518240000008897067894872775073_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M319.267,377.917L298.441,73.059c-0.493-7.227-4.502-9.138-8.066-10.905 c-3.564-1.768-9.302-2.764-14.011-0.045l-120.55,69.599c-4.709,2.718-8.237,9.163-7.88,14.394L168.76,450.96 c0.357,5.231,4.107,8.24,7.671,10.008c3.564,1.768,9.698,3.662,14.407,0.943l120.55-69.6 C316.096,389.592,319.763,385.202,319.267,377.917z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M311.49,380.744l-123.962,71.569L166.66,146.24l-16.686-8.277 c-1.425,2.604-2.218,5.523-2.04,8.138L168.76,450.96c0.357,5.231,4.107,8.24,7.671,10.008c3.564,1.768,9.698,3.662,14.406,0.943 l120.55-69.6c2.941-1.698,5.792-4.216,7.121-8.086c0,0-0.516-0.256-0.516-0.256L311.49,380.744z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M289.196,70.823l-120.896,69.802c-3.297,1.899-5.784,6.441-5.535,10.095l20.669,302.577 c0.383,5.615,4.844,7.822,9.899,4.898l117.681-67.939c3.728-2.155,6.549-7.299,6.266-11.446L296.49,74.441 C296.207,70.294,292.924,68.669,289.196,70.823z"
  }), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M291.276,87.885l19.43,284.405c0.269,3.95-2.405,8.844-5.95,10.882l-108.989,62.926c-3.553,2.067-6.656,0.529-6.926-3.43 L169.281,156.35c-0.218-3.201,1.486-7.022,4.053-9.438c0.202-0.184,0.394-0.369,0.597-0.544c0.418-0.331,0.857-0.635,1.3-0.891 l30.656-17.701c0,0,0.895-0.521,1.998-1.152c1.103-0.64,2.066-0.167,2.15,1.064c0.083,1.222,1.107,1.675,2.288,0.986 l35.726-20.624c1.171-0.679,2.069-2.225,1.985-3.447c-0.078-1.146,0.644-2.556,1.64-3.26c0.068-0.049,0.137-0.088,0.206-0.128 l29.987-17.307l0.639-0.374C286.996,80.947,290.936,82.903,291.276,87.885z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M281.867,83.91l-29.987,17.307c-0.069,0.039-0.138,0.079-0.206,0.127 c-0.996,0.704-1.718,2.114-1.64,3.26c0.083,1.222-0.814,2.768-1.985,3.447l-35.726,20.624c-1.181,0.689-2.204,0.236-2.288-0.986 c-0.084-1.231-1.047-1.704-2.15-1.064c-1.103,0.63-1.999,1.152-1.999,1.152l-30.656,17.701c-0.443,0.256-0.883,0.559-1.3,0.891 c-0.203,0.175-0.395,0.359-0.597,0.544c-2.567,2.416-4.271,6.236-4.053,9.438l19.561,286.319c0.035,0.516,0.121,0.989,0.247,1.42 c0.483-0.152,0.979-0.365,1.487-0.661l108.989-62.926c3.545-2.038,6.219-6.932,5.95-10.882l-19.43-284.405 c-0.072-1.057-0.314-1.969-0.682-2.739c-0.916,0.141-1.89,0.481-2.895,1.061L281.867,83.91z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M217.238,118.075l16.377-9.455c0.977-0.564,1.825-0.196,1.895,0.822 c0.069,1.018-0.666,2.301-1.643,2.865l-16.377,9.455c-0.977,0.564-1.825,0.196-1.895-0.822 C215.525,119.922,216.261,118.639,217.238,118.075z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M241.967,103.02c1.101-0.635,2.06-0.159,2.144,1.063c0.083,1.223-0.741,2.729-1.842,3.365 c-1.101,0.635-2.06,0.16-2.144-1.063C240.042,105.162,240.867,103.656,241.967,103.02z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M162.865,194.576c-0.141-2.061-1.772-4.484-3.644-5.413c-0.904-0.448-1.693-0.461-2.253-0.124 c-0.395,0.238-1.952,1.105-2.364,1.353c-0.598,0.359-0.934,1.115-0.862,2.174l1.561,22.886c0.141,2.061,1.772,4.484,3.644,5.413 c0.863,0.428,1.621,0.459,2.176,0.168c0.436-0.229,2.026-1.148,2.437-1.393c0.601-0.357,0.939-1.115,0.866-2.176 L162.865,194.576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M160.521,195.928l1.561,22.886c0.141,2.061-1.263,2.979-3.135,2.05 c-1.872-0.929-3.504-3.352-3.644-5.413l-1.561-22.886c-0.141-2.061,1.263-2.979,3.135-2.05 C158.749,191.443,160.38,193.867,160.521,195.928z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M165.597,234.632c-0.141-2.061-1.772-4.484-3.644-5.413c-0.904-0.448-1.693-0.462-2.253-0.124 c-0.395,0.238-1.952,1.105-2.364,1.353c-0.598,0.359-0.934,1.114-0.862,2.174l1.561,22.886c0.141,2.061,1.772,4.484,3.644,5.413 c0.863,0.428,1.621,0.459,2.176,0.168c0.436-0.229,2.026-1.148,2.437-1.393c0.601-0.358,0.939-1.115,0.866-2.176 L165.597,234.632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M163.253,235.983l1.561,22.886c0.141,2.061-1.263,2.979-3.135,2.05 c-1.872-0.929-3.504-3.352-3.644-5.413l-1.561-22.886c-0.141-2.061,1.263-2.979,3.135-2.05 C161.481,231.499,163.112,233.922,163.253,235.983z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_00000011011932338702156750000012276624753848479417_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_00000135687179257911239390000017842068638285699496_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000137832594481463541720000009894034151669566907_",
    style: {
      fill: "#BA68C8"
    },
    d: "M194.906,86.759l-3.002-5.645 l2.416-6.973v-4.268l-7.392,4.268v4.268l3.178,5.505c0.054,0.093,0.131,0.154,0.216,0.192l-0.002,0.003L194.906,86.759z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000054967069481104271970000016985104520498445751_",
    style: {
      opacity: 0.15
    },
    d: "M194.906,86.759l-3.002-5.645 l2.416-6.973v-4.268l-7.392,4.268v4.268l3.178,5.505c0.054,0.093,0.131,0.154,0.216,0.192l-0.002,0.003L194.906,86.759z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000116215345775093883510000013265166863763584427_",
    style: {
      fill: "#BA68C8"
    },
    d: "M214.264,34.961 c0-1.413-0.992-3.132-2.216-3.839l-1.805-1.042c-1.224-0.707-3.208-0.707-4.433,0l-35.076,20.287 c-1.224,0.707-2.217,2.425-2.217,3.839v30.451c0,1.414,0.993,3.132,2.217,3.839l1.805,1.042c1.224,0.707,3.209,0.707,4.433,0 l14.597-8.44l3.172,5.494c0.203,0.351,0.725,0.302,0.857-0.082l3.352-9.676l13.098-7.583c1.224-0.706,2.216-2.425,2.216-3.839 L214.264,34.961z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000023254789216507852000000011717563067862794626_",
    style: {
      opacity: 0.15
    },
    d: "M168.518,84.657 c0,1.414,0.993,3.132,2.216,3.839l1.805,1.042c1.107,0.639,2.828,0.694,4.054,0.179c-1.043,0.395-1.837-0.194-1.837-1.458 l0-30.451c0-0.707,0.248-1.489,0.649-2.184l-6.237-3.601c-0.401,0.694-0.649,1.477-0.649,2.184V84.657z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000093140780794973097150000017514157958320131462_",
    style: {
      opacity: 0.45,
      fill: "#FFFFFF"
    },
    d: "M214.191,34.331 c-0.259-0.941-1.117-1.241-2.14-0.651l-35.081,20.29c-0.61,0.351-1.168,0.951-1.561,1.654l-6.235-3.598 c0.403-0.703,0.951-1.303,1.561-1.654l35.07-20.29c1.23-0.703,3.215-0.703,4.436,0l1.809,1.044 C213.096,31.725,213.974,33.069,214.191,34.331z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M196.827,54.746l-6.149,3.55v-4.85l-10.93,16.312l10.93,3.691V68.6l6.149-3.55 c5.939-3.429,9.191-4.39,10.953-0.022C208.962,53.601,204.18,50.501,196.827,54.746z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_00000118379495294967496280000010128275639023518091_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_00000055694918581705959850000005607933434272291742_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000092438938073340433680000010016310983309121704_",
    style: {
      fill: "#BA68C8"
    },
    d: "M375.46,390.139l-3.002-5.645 l2.416-6.973v-4.268l-7.392,4.268v4.268l3.178,5.505c0.054,0.093,0.131,0.154,0.216,0.192l-0.002,0.003L375.46,390.139z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000075126931366742400390000004342063639061808798_",
    style: {
      opacity: 0.15
    },
    d: "M375.46,390.139l-3.002-5.645 l2.416-6.973v-4.268l-7.392,4.268v4.268l3.178,5.505c0.054,0.093,0.131,0.154,0.216,0.192l-0.002,0.003L375.46,390.139z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000157269331955868830820000011373973923133001896_",
    style: {
      fill: "#BA68C8"
    },
    d: "M394.818,338.341 c0-1.413-0.992-3.132-2.216-3.839l-1.805-1.042c-1.224-0.707-3.208-0.707-4.433,0l-35.076,20.287 c-1.224,0.707-2.217,2.426-2.217,3.839v30.451c0,1.414,0.993,3.132,2.217,3.839l1.805,1.042c1.224,0.707,3.209,0.707,4.433,0 l14.597-8.44l3.172,5.494c0.203,0.351,0.724,0.302,0.857-0.082l3.352-9.676l13.098-7.583c1.224-0.706,2.216-2.425,2.216-3.839 L394.818,338.341z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000115501268400109036740000010220635994096891788_",
    style: {
      opacity: 0.15
    },
    d: "M349.072,388.037 c0,1.414,0.992,3.132,2.216,3.839l1.805,1.042c1.107,0.639,2.828,0.694,4.054,0.179c-1.043,0.395-1.837-0.194-1.837-1.458 l0-30.451c0-0.707,0.248-1.49,0.649-2.184l-6.237-3.601c-0.401,0.695-0.649,1.477-0.649,2.184V388.037z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000178177756697294629340000013327395965499629494_",
    style: {
      opacity: 0.45,
      fill: "#FFFFFF"
    },
    d: "M394.745,337.711 c-0.259-0.941-1.117-1.241-2.14-0.651l-35.081,20.29c-0.61,0.351-1.168,0.951-1.562,1.654l-6.235-3.598 c0.403-0.703,0.951-1.303,1.561-1.654l35.07-20.29c1.23-0.703,3.215-0.703,4.436,0l1.809,1.044 C393.649,335.106,394.528,336.45,394.745,337.711z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M361.534,382.697c1.762-6.402,5.014-9.196,10.953-12.625l6.149-3.55v4.85l10.93-16.312 l-10.93-3.691v4.85l-6.149,3.55C365.133,364.014,360.351,372.635,361.534,382.697z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Character_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow_00000180364122826735091380000008357394678891496325_",
    style: {
      opacity: 0.15
    },
    d: "M230.847,425.394 c28.993,6.965,44.096,32.785,77.844,25.81c11.869-1.816,27.67-11.818,16.444-22.473c-20.812-14.881-48.105-8.359-71.207-19.129 c-8.302-3.539-16.751-10.081-25.307-12.899c-9.154-2.594-19.089-3.808-27.918,0.632c-2.194,0.925-5.73,3.457-4.924,8.754 C197.63,418.26,220.507,422.246,230.847,425.394z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bottom_00000102542188856302650390000007288912803716249481_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M231.43,406.379c0.67-3.587-2.845-5.711-4.541-7.698c-2.624-3.073-3.505-7.938-3.627-11.7 c-0.151-4.693-0.83-8.022,1.832-12.368c3.151-5.145,7.581-11.197,22.615-26.163l-20.662-9.779 c-3.766,6.658-12.353,20.391-12.353,20.391l-0.791,1.206c-1.814,2.43-2.807,4.31-5.646,6.438 c-0.014,0.01-1.031,0.593-1.044,0.603c-1.781,1.358-6.386,2.899-6.129,7.393c0.257,4.494,2.002,5.543,4.116,9.153 c1.348,2.301,2.312,3.458,2.581,7.946c0.217,3.616,0.045,5.182,0.136,8.422c0.077,2.727,2.674,6.597,7.825,8.184 C223.248,410.719,230.771,409.908,231.43,406.379z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000060738831245524184610000018172881596945716659_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M198.456,374.926c-1.218,1.69-4.372,7.38-5.163,10.068l5.397,7.193l3.99-7.605 C202.679,384.583,199.395,380.043,198.456,374.926z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.689,392.188l6.989-0.754c0,0,0.508-2.48-0.868-4.439c-1.375-1.959-2.131-2.412-2.131-2.412L198.689,392.188z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M199.796,373.209c0,0-0.995,0.813-1.294,1.555c-0.301,0.746,0.26,5.36,1.806,7.548 c1.546,2.188,4.013,4.479,4.725,7.649c0.712,3.171-0.411,8.105,0.999,12.519c1.409,4.414,5.779,9.361,14.917,10.229 c6.531,0.62,8.932-0.739,11.049-2.218c0.671-2.922,0.565-3.674-3.082-5.988C225.269,402.19,199.796,373.209,199.796,373.209z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000095304836876346612940000007132971311491047310_",
    style: {
      fill: "#37474F"
    },
    d: "M211.432,360.984 c-2.772,3.685-3.763,5.099-6.38,6.802c-3.167,2.061-3.809,2.868-5.256,5.423c-0.502,3.889,0.316,5.462,3.952,10.278 c2.488,3.296,3.349,5.491,3.467,10.144c0.143,5.629-1.696,8.356,5.174,13.87c5.35,4.295,16.676,4.177,19.624,0.947 c2.324-7.775-4.388-6.975-6.296-15.053c-1.057-4.475-2.025-9.421-0.835-13.973c0.411-1.572,1.096-2.981,1.937-4.354 c0.758-1.237,3.052-4.027,1.674-5.501l-0.936,1.324c-1.63,0.434-5.271-0.169-7.98-2.251c-6.539-5.024-5.674-8.372-5.674-8.372 l0.791-1.206C214.021,358.292,213.005,358.894,211.432,360.984z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M251.293,272.31l15.332-20.922c0,0,30.544-16.971,30.547-17.654c0,0,6.061,17.49,1.508,41.187 c-4.746,24.704-17.59,42.702-24.112,50.345c-6.522,7.643-40.333,37.705-40.333,37.705c-3.39-0.488-12.849-7.922-14.042-12.807 c0,0,7.402-13.261,11.776-20.073c5.713-8.895,7.391-13.149,18.109-20.619C249.224,300.33,251.293,272.31,251.293,272.31z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M224.567,349.292l-0.694-0.443l0.417-0.653c10.279-16.082,20.052-31.022,42.826-35.907 l0.172,0.805c-22.438,4.813-32.108,19.592-42.304,35.546L224.567,349.292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M242.818,315.266c0.354-0.336,0.723-0.674,1.11-1.017c0.152-0.134,0.308-0.27,0.466-0.406 c0.367-0.317,0.752-0.639,1.151-0.965c0.183-0.149,0.364-0.298,0.555-0.449c0.42-0.335,0.867-0.678,1.325-1.024 c0.188-0.142,0.365-0.281,0.56-0.425c0.66-0.49,1.351-0.989,2.095-1.507c-0.035-0.375-0.064-0.792-0.089-1.228 c-0.006-0.11-0.013-0.224-0.019-0.338c-0.021-0.414-0.04-0.845-0.054-1.303c-0.001-0.039-0.003-0.075-0.004-0.115 c-0.015-0.504-0.024-1.038-0.031-1.589c-0.002-0.125-0.003-0.253-0.004-0.38c-0.004-0.512-0.006-1.036-0.005-1.58 c0-0.054,0-0.106,0-0.161c0.002-0.614,0.008-1.248,0.018-1.895c0.002-0.106,0.003-0.213,0.005-0.32 c0.009-0.613,0.021-1.236,0.036-1.872c0.001-0.04,0.001-0.078,0.002-0.118c0.017-0.714,0.037-1.44,0.06-2.174 c0.001-0.023,0.002-0.047,0.002-0.071c0.023-0.728,0.048-1.463,0.075-2.202c0-0.01,0.001-0.021,0.001-0.031l29.833-24.937 c0.135-0.652,14.219-9.798,14.219-9.798c-1.024,8.951-10.215,13.077-10.215,13.077l3.134,34.505 c-0.185,0.309-2.637,4.563-2.822,4.865c-0.218,0.357-0.435,0.716-0.652,1.063c-0.351,0.56-0.698,1.1-1.045,1.634 c-0.175,0.27-0.352,0.552-0.526,0.815c-0.501,0.757-0.996,1.486-1.482,2.187c-0.179,0.257-0.352,0.496-0.529,0.745 c-0.327,0.463-0.654,0.922-0.973,1.358c-0.194,0.266-0.384,0.521-0.575,0.776c-0.295,0.396-0.587,0.784-0.871,1.155 c-0.178,0.233-0.356,0.464-0.53,0.687c-0.303,0.388-0.597,0.758-0.885,1.115c-0.134,0.167-0.272,0.341-0.403,0.501 c-0.411,0.504-0.81,0.984-1.183,1.421c-3.512,4.117-14.936,14.732-24.735,23.655c-0.215-4.339,0.033-9.004,0.46-14.122 l-7.706-19.317C242.663,315.411,242.742,315.339,242.818,315.266z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M217.487,354.568c0,0-0.32,4.244,5.267,8.595c4.417,3.441,8.863,3.009,8.863,3.009l6.601-6.464 c0,0-3.516,0.952-9.039-3.812c-5.791-4.995-6.052-11.218-6.052-11.218L217.487,354.568z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M278.289,427.44c1.771,5.19,7.885,6.337,12.678,4.749c2.705-0.896,4.008-3.962,5.718-5.999 c2.528-3.01,6.263-4.704,9.933-6.111c3.671-1.407,7.49-2.667,10.578-5.1c2.612-2.058,4.588-4.913,5.593-8.083 c0.32-1.01,0.546-2.084,0.358-3.127c-0.452-2.519-3.224-4.061-5.783-4.065c-2.559-0.003-4.961,1.13-7.31,2.148 c-3.17,1.373-6.415,2.574-9.715,3.594c-1.037,0.321-2.098,0.626-3.184,0.627c-1.709,0.001-4.312-1.338-4.965-2.801 c-1.042-2.335-2.229-28.24-2.211-29.442l-24.703,6.256c0,0,9.263,27.993,10.738,32.714c0.144,0.46,0.233,0.933,0.315,1.407 C277.084,418.601,276.832,423.171,278.289,427.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M243.596,233.734c-8.426,17.528-11.553,24.414-8.049,42.072 c2.387,12.027,10.033,32.026,19.226,58.993c-0.646,15.465,1.679,20.141,4.955,30.899c5.011,16.456,11.073,31.126,11.073,31.126 s4.339-6.88,20.297-5.951c-0.985-15.555-1.898-46.075-3.197-57.348c-1.929-16.739-7.391-64.53-7.391-64.53 s20.928-0.521,16.662-35.261H243.596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M276.25,392.855c-3.597-9.423-7.453-20.323-9.605-28.641c-2.546-9.839-3.344-16.657-3.602-20.749 c-0.263-4.157-0.317-9.276-0.411-11.083c-0.31-5.97-2.889-18.612-7.543-32.465c-4.112-12.242-6.462-24.746-7.688-32.145 c0.139,0.007,0.28,0.027,0.417,0.027c1.647,0,3.18-0.55,4.567-1.639c4.123-3.238,6.932-11.136,8.352-23.473l-0.819-0.095 c-1.374,11.941-4.154,19.866-8.042,22.92c-1.388,1.09-2.935,1.568-4.604,1.433c-1.712-11.774,1.317-20.214,4-27.666 c0.688-1.911,1.331-3.723,1.893-5.545h-0.866c-0.54,1.724-1.149,3.449-1.803,5.266c-2.739,7.612-5.846,16.239-3.997,28.391 c1.124,7.392,3.593,20.239,7.808,32.788c4.431,13.191,7.197,26.388,7.501,32.245c0.091,1.756,0.15,6.884,0.411,10.981 c0.264,4.136,0.923,10.419,3.671,20.81c2.069,7.822,6.085,19.957,9.615,29C275.738,393.093,276,392.975,276.25,392.855z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M321.322,398.658c-2.193-2.299-6.616-0.785-9.464,0.371c-6.016,2.441-7.834,4.106-12.29,4.959 c-6.462,1.237-6.261-2.467-6.261-2.467s-4.705-3.418-13.052,1.14c-5.929,3.238-5.877,7.447-5.877,7.447 s1.74,3.818,1.973,9.866c0.232,6.047,0.771,7.968,1.539,9.673l26.931-17.615l1.922-0.452 C312.565,408.412,321.322,398.658,321.322,398.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M324.622,403.055c-0.287-1.72-0.88-2.799-1.693-3.383c-0.311-0.224-1.399-0.863-1.608-1.014 c-2.766-1.995-8.087,1.745-12.598,5.452c-5.255,4.318-14.362,4.95-18.735,10.954c-4.373,6.005-9.543,8.143-11.346,10.797 c-1.279,1.883-1.066,4.034,0.212,5.575c0.246,0.296,1.159,1.234,1.341,1.426c1.273,1.346,3.613,1.98,6.435,1.579 c5.694-0.81,9.835-2.404,14.823-8.818c4.988-6.415,10.746-3.093,16.397-7.092 C323.504,414.533,325.524,408.461,324.622,403.055z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M324.622,403.055c-1.264-7.576-8.456-2.716-14.29,2.078c-5.254,4.318-14.361,4.949-18.734,10.954 c-4.373,6.005-9.663,8.066-11.346,10.796c-3.059,4.965,0.685,8.368,6.379,7.559c5.694-0.81,9.835-2.404,14.823-8.818 c4.988-6.415,10.746-3.093,16.397-7.092C323.503,414.533,325.524,408.461,324.622,403.055z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M304.29,422.015l-12.692-5.927c-4.373,6.005-9.663,8.066-11.346,10.796 c-1.544,2.505-1.881,3.847-1.881,3.847l1.971,4.292c0.032,0.036,0.632,0.682,0.666,0.718l0.018,0.02l0.002-0.001 c1.281,1.319,3.601,1.942,6.396,1.544c5.693-0.809,9.835-2.403,14.823-8.818c1.031-1.326,1.958-2.514,2.836-3.609 L304.29,422.015z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M281.045,429.744c-3.059,4.965,0.685,8.368,6.379,7.559c5.693-0.809,9.835-2.403,14.823-8.818 c1.031-1.326,1.958-2.514,2.836-3.609l-12.693-5.927C288.017,424.953,282.727,427.014,281.045,429.744z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M267.399,388.11l4.158,11.009c0,0,5.242-6.441,19.679-5.462l-0.678-12.082 C290.558,381.575,276.309,378.618,267.399,388.11z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Top_00000015332664863788368970000009455829957138605190_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M268.435,128.774c-7.934-0.4-11.475,6.841-10.48,15.255c0.781,6.602-0.291,9.515-4.076,13.445 c-3.784,3.93-6.727,7.549-3.202,14.013c3.525,6.463,2.766,8.96,0.873,12.598c14,11.279,36.119,10.508,52.223,4.221 c15.948-6.226,14.374-15.321,14.374-15.321s-5.684,2.057-7.608-2.973c-2.425-6.34,7.958-6.581,5.772-15.916 c-1.301-5.554-6.341-6.792-5.613-11.725c0.352-2.387,4.46-8.568-0.634-15.488c-4.779-6.492-12.599-11.156-26.522-9.588 C277.125,118.017,269.325,122.393,268.435,128.774z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M317.981,194.216c7.341,10.398,8.65,12.475,8.65,12.475c5.162-10.05,9.098-17,10.524-21.454 c1.426-4.453,9.697-12.953,9.697-12.953c4.376,2.344,6.257,10.57,2.068,17.497c-3.047,5.038-3.023,19.1-10.641,35.861 c-3.984,8.765-9.604,9.704-18.126,1.725c-5.971-5.591-16.269-17.674-16.269-17.674l-7.129-35.396 C307.493,176.186,310.83,184.087,317.981,194.216z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000101790540802116219760000017652426768537559996_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000016054196190325476340000007873828407568309666_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000057844226531966397240000005333501979593481149_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_10772_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_10796_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M360.164,176c-0.865,3.026-2.565,4.816-3.566,6.233c-3.891,5.509-5.073,4.461-8.604,8.566 l-1.876-14.297c-1.263-4.397,0.89-5.69,4.488-5.67L360.164,176z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Megaphone_00000167362689299967386620000006478788609557456280_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M331.713,163.475c2.844,3.098,7.66,3.303,10.758,0.459 c3.097-2.844,3.303-7.661,0.459-10.758c-2.844-3.097-7.66-3.303-10.758-0.459 C329.075,155.562,328.869,160.378,331.713,163.475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M335.167,161.611c1.56-0.347,5.607-1.249,9.683-2.157 c-0.248,1.663-1.044,3.255-2.379,4.481c-3.097,2.844-7.914,2.638-10.758-0.459c-1.067-1.161-1.704-2.565-1.921-4.016 C330.604,161.35,332.053,162.304,335.167,161.611z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_913_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6588_",
    style: {
      fill: "#37474F"
    },
    d: "M341.978,161.186l1.834-5.846c2.941,5.612,8.484,12.997,13.35,17.677 l-0.734,2.338C352.772,173.209,346.972,167.304,341.978,161.186z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000054261602768451448540000018259199660548507836_",
    style: {
      fill: "#455A64"
    },
    d: "M337.193,165.51 l3.573,0.585l5.678,6.101c2.543,2.732,6.332,3.931,9.983,3.158l0,0c-4.199-2.697-9.855-8.642-14.45-14.169 L337.193,165.51z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M348.814,167.731c-0.018,0.058-0.036,0.116-0.054,0.172 c-0.086,0.275-0.385,0.549-0.667,0.612l-1.369,0.305c-0.282,0.063-0.352,0.286-0.157,0.498l0.12,0.131 c0.195,0.212,0.582,0.334,0.863,0.272l1.392-0.309c0.281-0.063,0.577-0.337,0.659-0.614l0.048-0.162 c0.082-0.277-0.009-0.673-0.204-0.886l-0.122-0.133C349.129,167.404,348.9,167.455,348.814,167.731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M350.8,169.613c-0.018,0.058-0.036,0.116-0.054,0.172 c-0.086,0.275-0.385,0.549-0.666,0.612l-1.369,0.305c-0.282,0.063-0.352,0.286-0.157,0.498l0.12,0.131 c0.195,0.213,0.582,0.334,0.863,0.272l1.392-0.309c0.282-0.062,0.577-0.337,0.659-0.614l0.049-0.163 c0.082-0.276-0.01-0.673-0.204-0.886l-0.122-0.133C351.115,169.287,350.887,169.338,350.8,169.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M352.787,171.495c-0.018,0.059-0.037,0.117-0.054,0.172 c-0.086,0.275-0.385,0.549-0.667,0.612l-1.369,0.305c-0.282,0.063-0.352,0.286-0.157,0.498l0.12,0.131 c0.195,0.212,0.582,0.334,0.863,0.272l1.392-0.309c0.282-0.062,0.577-0.337,0.659-0.614l0.049-0.163 c0.082-0.277-0.009-0.673-0.204-0.885l-0.122-0.133C353.102,171.169,352.873,171.22,352.787,171.495z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_869_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_912_",
    style: {
      fill: "#BA68C8"
    },
    d: "M341.532,148.241v0.004c-1.146,0.258-2.14,1.203-2.758,2.781 c-0.066,0.164-0.127,0.336-0.185,0.517c-0.066,0.214-0.125,0.427-0.176,0.651c-0.086,0.366-0.152,0.742-0.196,1.13 c-0.085,0.706-0.106,1.441-0.065,2.188c0.11,2.005,0.654,4.08,1.544,5.834c0.45,0.884,0.987,1.686,1.604,2.357 c1.309,1.426,2.729,1.991,3.976,1.754l-4.319,0.966l-0.001-0.009c-1.563,0.279-3.27-0.217-4.558-1.62 c-0.588-0.641-1.107-1.402-1.542-2.24c-0.926-1.777-1.492-3.9-1.604-5.949c-0.04-0.747-0.022-1.484,0.066-2.188 c0.044-0.388,0.108-0.766,0.196-1.13c0.05-0.223,0.109-0.441,0.176-0.651c0.056-0.179,0.12-0.352,0.19-0.519 c0.645-1.522,1.867-2.512,3.249-2.884v-0.004l0.12-0.028c0.05-0.011,0.102-0.024,0.155-0.032L341.532,148.241z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000118398781855315804420000012744713827764416139_",
    style: {
      opacity: 0.1
    },
    d: "M340.957,166.422 l-0.001-0.009c-1.563,0.279-3.27-0.217-4.558-1.62c-0.588-0.641-1.107-1.402-1.542-2.24l4.841-1.208 c0.45,0.884,0.987,1.686,1.604,2.357c1.309,1.426,2.729,1.991,3.976,1.754L340.957,166.422z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000052804585014783457960000005569887575240897201_",
    style: {
      fill: "#BA68C8"
    },
    d: "M345.611,149.979 c2.687,2.927,3.9,8.369,2.709,12.158c-0.597,1.906-1.692,3.032-2.973,3.304c-0.022,0.007-0.047,0.011-0.071,0.016 c-1.247,0.237-2.667-0.328-3.976-1.754c-2.687-2.926-3.9-8.369-2.711-12.16c0.594-1.89,1.676-3.014,2.943-3.298 C342.804,147.957,344.264,148.513,345.611,149.979z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000068650872303284180500000017962856307255741102_",
    style: {
      opacity: 0.2
    },
    d: "M345.611,149.979 c2.687,2.927,3.9,8.369,2.709,12.158c-0.597,1.906-1.692,3.032-2.973,3.304c-0.022,0.007-0.047,0.011-0.071,0.016 c-1.247,0.237-2.667-0.328-3.976-1.754c-2.687-2.926-3.9-8.369-2.711-12.16c0.594-1.89,1.676-3.014,2.943-3.298 C342.804,147.957,344.264,148.513,345.611,149.979z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_887_",
    style: {
      fill: "#BA68C8"
    },
    d: "M358.982,136.307c0,0-2.447,6.625-0.114,17.101 c0.458,2.057,1.022,3.904,1.63,5.54c2.486,6.693,5.731,9.896,5.731,9.896c-4.482-2.111-9.409-4.035-14.729-4.086 c-3.293-0.032-6.219,0.288-6.219,0.288l-0.001-0.005c-1.161,0.256-2.479-0.294-3.687-1.609 c-0.795-0.867-1.456-1.961-1.956-3.172c-0.32-0.764-0.575-1.574-0.759-2.4c-0.475-2.132-0.48-4.367,0.094-6.197 c0.536-1.703,1.497-2.76,2.656-3.021l-0.001-0.005c0,0,2.785-0.952,5.754-2.379 C352.176,143.953,355.82,140.12,358.982,136.307z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_886_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M358.982,136.307c0,0-2.447,6.625-0.114,17.101 c0.458,2.057,1.022,3.904,1.63,5.54c2.486,6.693,5.731,9.896,5.731,9.896c-4.482-2.111-9.409-4.035-14.729-4.086 c-3.293-0.032-6.219,0.288-6.219,0.288l-0.001-0.005c-1.161,0.256-2.479-0.294-3.687-1.609 c-0.795-0.867-1.456-1.961-1.956-3.172c-0.32-0.764-0.575-1.574-0.759-2.4c-0.475-2.132-0.48-4.367,0.094-6.197 c0.536-1.703,1.497-2.76,2.656-3.021l-0.001-0.005c0,0,2.785-0.952,5.754-2.379 C352.176,143.953,355.82,140.12,358.982,136.307z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_885_",
    style: {
      opacity: 0.1
    },
    d: "M360.499,158.948c2.486,6.693,5.731,9.896,5.731,9.896 c-4.482-2.111-9.409-4.035-14.729-4.086c-3.293-0.032-6.219,0.288-6.219,0.288l-0.001-0.005 c-1.161,0.256-2.479-0.294-3.687-1.609c-0.795-0.867-1.456-1.961-1.956-3.172 C344.756,158.796,353.405,156.824,360.499,158.948z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_884_",
    style: {
      fill: "#BA68C8"
    },
    d: "M373.765,134.905c2.802,3.052,4.93,7.254,6.197,11.774l0.002,0.002 c1.622,5.791,1.836,12.094,0.244,17.159c-2.834,9.017-10.313,10.682-16.704,3.721c-1.463-1.593-2.74-3.498-3.81-5.598 c-2.63-5.174-3.988-11.526-3.679-17.285c0.042-0.811,0.118-1.609,0.23-2.392c0.045-0.325,0.098-0.65,0.156-0.969 l0.002-0.002c0.082-0.455,0.175-0.902,0.283-1.341c0.112-0.457,0.235-0.907,0.374-1.347 C359.893,129.61,367.372,127.942,373.765,134.905z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_881_",
    style: {
      opacity: 0.1
    },
    d: "M379.964,146.68c1.622,5.791,1.836,12.094,0.244,17.159 c-2.834,9.017-10.313,10.682-16.704,3.721c-1.463-1.593-2.74-3.498-3.81-5.598l0.002-0.002 c1.235,0.526,3.881,0.465,3.71-1.038c0.965,1.873,2.102,3.559,3.386,4.958c1.837,2.001,3.766,3.205,5.579,3.488 c1.546,0.24,2.955-0.21,4.183-1.341c1.197-1.095,2.181-2.811,2.857-4.953c1.354-4.307,1.258-9.726,0.028-14.834 C379.439,148.241,380.106,148.214,379.964,146.68z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000041282555392782725590000003372966241387617672_",
    style: {
      fill: "#BA68C8"
    },
    d: "M373.375,135.979 c2.823,3.074,4.931,7.536,6.064,12.262c1.23,5.109,1.326,10.527-0.028,14.834c-0.675,2.142-1.66,3.857-2.857,4.953 c-1.228,1.131-2.637,1.581-4.183,1.341c-1.813-0.282-3.741-1.487-5.579-3.488c-1.284-1.399-2.421-3.085-3.386-4.958 c-0.366-0.707-0.706-1.441-1.019-2.195c-0.547-1.314-1.018-2.696-1.396-4.104c-0.078-0.29-0.153-0.579-0.224-0.869 c-0.12-0.482-0.23-0.969-0.326-1.456c-0.338-1.665-0.549-3.351-0.628-5.005c-0.001-0.017,0-0.039-0.003-0.057 c-0.051-1.102-0.044-2.187,0.024-3.245c0.049-0.762,0.131-1.507,0.243-2.234c0.046-0.305,0.1-0.606,0.159-0.905 c0.072-0.357,0.152-0.711,0.239-1.06c0.087-0.338,0.182-0.671,0.283-0.997c0.674-2.151,1.664-3.861,2.857-4.96 C366.263,131.403,369.913,132.208,373.375,135.979z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_877_",
    style: {
      opacity: 0.4
    },
    d: "M373.375,135.979c2.823,3.074,4.931,7.536,6.064,12.262 c1.23,5.109,1.326,10.527-0.028,14.834c-0.675,2.142-1.66,3.857-2.857,4.953c-1.228,1.131-2.637,1.581-4.183,1.341 c-1.813-0.282-3.741-1.487-5.579-3.488c-1.284-1.399-2.421-3.085-3.386-4.958c-0.366-0.707-0.706-1.441-1.019-2.195 c-0.547-1.314-1.018-2.696-1.396-4.104c-0.078-0.29-0.153-0.579-0.224-0.869c-0.12-0.482-0.23-0.969-0.326-1.456 c-0.338-1.665-0.549-3.351-0.628-5.005c-0.001-0.017,0-0.039-0.003-0.057c-0.051-1.102-0.044-2.187,0.024-3.245 c0.049-0.762,0.131-1.507,0.243-2.234c0.046-0.305,0.1-0.606,0.159-0.905c0.072-0.357,0.152-0.711,0.239-1.06 c0.087-0.338,0.182-0.671,0.283-0.997c0.674-2.151,1.664-3.861,2.857-4.96 C366.263,131.403,369.913,132.208,373.375,135.979z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000113320510357155738450000001461870102893923263_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000143594074885671513060000010165201038812332990_",
    style: {
      fill: "#37474F"
    },
    d: "M367.913,145.879 l2.325,10.004c-2.323,0.607-5.172,1.324-7.528,3.589c-0.112-0.245-0.217-0.492-0.321-0.744 c-0.547-1.314-1.018-2.696-1.396-4.104c-0.078-0.29-0.153-0.58-0.224-0.869c-0.12-0.482-0.23-0.969-0.326-1.456 c-0.338-1.665-0.549-3.351-0.628-5.005c-0.001-0.017,0-0.039-0.003-0.057c-0.01-0.243-0.02-0.485-0.024-0.726 C362.941,147.544,367.913,145.879,367.913,145.879z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000112596797688944469570000006539306747739097764_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000040570552250803205030000015248804975712277423_",
    style: {
      fill: "#BA68C8"
    },
    d: "M370.851,155.515 c-0.812,0.746-1.9,0.535-2.908-0.564l-0.031-0.033c-1.586-1.728-2.304-4.953-1.601-7.19l0.014-0.043 c0.187-0.597,0.467-1.078,0.81-1.393c0.812-0.746,1.9-0.535,2.909,0.564l0.031,0.034 c1.586,1.727,2.304,4.953,1.601,7.19l-0.013,0.044C371.474,154.719,371.194,155.2,370.851,155.515L370.851,155.515z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10801_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M350.672,165.708c-0.001-0.001,1.625-0.08,2.187-0.066 c1.345,0.035,2.405-0.199,3.132,0.973c0.248,0.4,0.291,1.051,0.598,1.398c0.348,0.394,1.216,0.478,1.692,0.708 c0.554,0.268,1.042,0.667,1.276,1.252c0.158,0.394,0.077,1.027,0.35,1.306c0.344,0.352,1.046,0.473,1.454,0.782 c0.919,0.697,0.875,2.134,1.027,3.164c0.165,1.111,0.51,2.682-0.19,3.66c-0.537,0.75-1.314,1.187-2.153,1.554 c-0.965,0.422-2.01,0.84-3.022,1.142c-0.879,0.262-1.608-0.301-1.942-1.052c-0.439-0.987-1.736-0.975-2.332-1.887 c-0.258-0.395-0.242-0.893-0.491-1.295c-0.3-0.485-0.581-0.807-0.596-1.403c-0.027-1.037,0.7-1.968,1.125-2.863 c0.37-0.781,0.395-1.803,0.364-2.663c-0.023-0.661-0.077-1.69-0.519-2.245 C352.633,168.175,350.678,165.716,350.672,165.708z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000156553420197228042990000003747746047913439933_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M337.155,185.237 c1.516-5.673,1.768-8.211,2.433-10.902c0.757-3.065,3.308-4.287,6.342-5.722c2.287-1.082,3.177-1.625,4.646-2.6 c1.203-0.823,1.252,2.634,0.764,3.808c-0.587,1.413-2.362,2.756-3.585,3.844c-2.786,2.477,4.327,8.608,0.238,17.135 C345.39,193.26,337.155,185.237,337.155,185.237z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Chest_00000176728470534133261330000013975365051403113661_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M238.842,240.419c2.941-4.523,6.564-10.577,9.404-15.175c2.871-4.647,3.084-11.202,2.653-16.636 c-0.466-5.886-1.751-21.826-0.349-27.012c0.798-2.951,3.772-5.584,9.98-6.554c5.697-0.891,11.581-1.485,17.713-1.623 c13.298-0.3,18.512,0.878,18.512,0.878c4.719,4.57,16.88,21.23,16.519,30.67c-0.462,12.115-9.305,14.324-9.305,14.324 s-4.126,6.867-5.089,10.933c-0.666,2.812,0.644,6.231,0.92,15.938c0,0-6.734,15.453-33.087,11.562 C244.948,254.51,238.842,240.419,238.842,240.419z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M288.996,221.179c-2.311,1.173-4.58,1.761-7.142,2.051c-2.406,0.273-4.873,0.17-7.185-0.524 c-1.961-0.589-3.72-1.624-5.305-2.812c-1.728-1.295-2.78-2.883-3.93-4.599c-0.156-0.232-0.29,0.13-0.258,0.257 c0.532,2.074,2.034,4.023,3.624,5.557c1.701,1.641,3.951,2.796,6.298,3.476c2.407,0.697,5.303,0.571,7.767,0.029 c2.383-0.524,4.365-1.75,6.192-3.183C289.139,221.367,289.142,221.105,288.996,221.179z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Head_00000137113283071643987920000010985320310468191889_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000156556012569832874810000000714146718713033878_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000014631590875237143920000002620198462701682870_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M303.6,132.376 c1.586,1.944,4.282,7.001,3.786,21.875c-0.359,10.761-3.748,12.85-7.535,14.404c-1.854,0.761-5.047,1.045-8.421,0.689 l-0.941,5.391c0,0,2.628,10.447,1.242,18.781c-15.921-5.818-22.166-17.825-22.166-17.825l3.279-18.602 c-0.868,1.577-4.897,3.253-8.032-0.338c-3.517-4.029-2.737-9.186,0.159-11.093c2.999-1.975,6.51-0.222,7.917,3.186 c0.73,3.159,4.143,2.907,4.522-1.256c4.361-2.086,4.717-7.015,3.156-12.168C286.634,129.352,300.488,130.789,303.6,132.376z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000136410082650892402440000003829735074486349467_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000153705970008695144560000002870216673930500272_",
    style: {
      fill: "#F28F8F"
    },
    d: "M294.553,143.493 l1.453,12.231l6.601-2.889C300.224,149.151,296.915,144.33,294.553,143.493z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000128452698995364238420000012070618941316009107_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000158746898059851393530000008353882749168810943_",
    style: {
      fill: "#F28F8F"
    },
    d: "M291.431,169.344 c-9.129-1.234-14.223-3.518-16.6-10.158c0,0,0.293,4.942,3.398,7.766c3.974,3.615,12.729,5.087,12.729,5.087L291.431,169.344z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000049901418352466526560000000966620173292504229_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000173879849607089652040000002690326993368555688_",
    style: {
      fill: "#B16668"
    },
    d: "M296.051,159.15l-5.66-1.923 c-0.599,1.544,0.183,3.225,1.746,3.756C293.699,161.514,295.452,160.693,296.051,159.15z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M293.42,161.122c-0.424,0.042-0.861,0.005-1.284-0.139c-1.09-0.37-1.786-1.303-1.913-2.354 C291.746,158.685,293.021,159.711,293.42,161.122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M286.82,146.219c-0.032,1.084,0.828,1.989,1.92,2.021c1.092,0.032,2.004-0.82,2.036-1.904 c0.032-1.084-0.827-1.989-1.92-2.021C287.763,144.283,286.852,145.135,286.82,146.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M300.152,145.581c0.132,1.076,1.118,1.841,2.203,1.708c1.085-0.133,1.857-1.113,1.725-2.19 c-0.132-1.076-1.118-1.841-2.203-1.708C300.792,143.524,300.02,144.504,300.152,145.581z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000000907366221720025630000001547207198683493791_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000088849770060830684140000014835973380890203320_",
    style: {
      fill: "#263238"
    },
    d: "M304.443,141.529 l-4.693-1.002c0.234-1.307,1.475-2.143,2.771-1.866C303.817,138.938,304.677,140.223,304.443,141.529z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000067223807906833251120000018181781863677989266_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000150104804592363645410000010501005749132303022_",
    style: {
      fill: "#263238"
    },
    d: "M285.392,142.567 l4.517-1.787c-0.454-1.267-1.834-1.893-3.082-1.4C285.581,139.874,284.938,141.301,285.392,142.567z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M247.801,178.955c-3.607,3.133-10.246,12.075-13.543,16.702 c-3.297,4.627-6.597,9.258-6.597,9.258c-2.45-5.401-7.65-16.887-8.601-19.183c-1.547-3.324-3.922-9.204-4.324-9.954 c-2.768-5.169-7.612-8.712-12.471-11.765c-0.833-0.523-1.672-1.036-2.512-1.547c-0.408-0.248-0.828-0.481-1.197-0.778 c-0.35-0.281-0.658-0.507-1.125-0.182c-0.329,0.23-0.503,0.626-0.59,1.018c-0.289,1.301,0.219,2.669,1.002,3.748 c0.782,1.079,1.822,1.939,2.777,2.869c0.732,0.713-0.418,0.898-0.973,0.906c-2.728,0.035-6.447-2.183-8.76-3.536 c-1.518-0.889-2.868-2.056-4.516-2.717c-1.014-0.406-2.143-0.601-3.206-0.351c-0.721,0.17-1.326,0.573-1.024,1.449 c0.188,0.545,0.652,0.938,1.064,1.341c0.849,0.831,1.598,1.585,1.616,2.846c0.011,0.794-0.134,1.605,0.08,2.369 c0.272,0.972,1.08,1.706,1.457,2.642c0.335,0.835,0.163,1.724,0.397,2.545c0.251,0.879,1.288,1.791,1.905,2.436 c1.472,1.538,3.18,2.841,5,3.94c2.765,1.67,3.519,2.057,6.57,3.118c1.669,0.581,4.067,0.831,5.45,3.439 c1.383,2.607,2.022,6.695,4.31,15.246c2.031,7.592,4.774,18.787,10.759,25.083c5.634,4.296,12.015-2.435,15.674-5.872 c2.464-2.314,17.242-20.413,17.242-20.413c7.25-10.918,7.671-19.253,6.865-28.569 C260.531,175.042,252.523,174.853,247.801,178.955z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M202.188,173.47c1.039,3.143,4.059,6.763,5.845,7.841c0,0-2.966-0.396-4.454-2.453 C201.949,176.604,201.988,174.718,202.188,173.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M227.662,204.915c1.886,4.632,2.823,11.394,2.094,16.387c2.393-7.594,1.717-13.842-0.39-18.78 L227.662,204.915z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Present_00000158029182714540475840000011178975229559499417_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Present"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_00000153666531030803115630000007367313249901772682_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M400.751,121.374c0.342,0.216,0.467,0.647,0.324,1.006c-2.318,5.283-7.404,9.919-12.848,11.914 c7.404,2.282,18.94-0.629,26.092-6.882c0.198-0.162,0.467-0.252,0.719-0.18c6.397,1.42,12.848,1.456,19.192,0.108 c24.331-5.193,39.929-29.219,34.735-53.568c-5.193-24.349-29.236-39.947-53.585-34.753 c-24.349,5.193-39.929,29.237-34.736,53.585C383.195,104.59,390.347,114.815,400.751,121.374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M399.296,122.363c-2.588,5.301-8.122,9.775-13.693,11.015c-0.341,0.072-0.593,0.359-0.629,0.683 c-0.054,0.341,0.126,0.683,0.431,0.845c7.691,3.953,21.186,1.204,29.668-6.002c6.505,1.384,13.064,1.402,19.479,0.036 c25.23-5.391,41.384-30.279,35.993-55.509c-5.373-25.229-30.279-41.366-55.491-35.993c-25.229,5.373-41.384,30.279-36.011,55.508 C381.65,105.13,388.82,115.552,399.296,122.363z M380.643,92.604c-5.193-24.349,10.386-48.392,34.736-53.585 c24.349-5.193,48.392,10.405,53.585,34.753c5.194,24.349-10.404,48.374-34.735,53.568c-6.343,1.348-12.795,1.312-19.192-0.108 c-0.252-0.072-0.521,0.018-0.719,0.18c-7.152,6.253-18.689,9.164-26.092,6.882c5.445-1.995,10.53-6.631,12.848-11.914 c0.144-0.359,0.018-0.791-0.324-1.006C390.347,114.815,383.195,104.59,380.643,92.604z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gift_46_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shadow_00000061438047483582031540000018131672689978515606_",
    style: {
      opacity: 0.1
    },
    points: "455.796,100.866  424.798,82.969 393.8,100.866 424.798,118.763  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gift_47_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000060005254728970810570000013177878860191591576_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000034784720783337622610000017188226626164794037_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000142888863862715602620000009375322024944600507_",
    style: {
      fill: "#BA68C8"
    },
    points: "424.798,116.379  397.388,100.536 397.388,76.281 396.81,75.948 396.81,67.868 424.798,84.027  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000165951697396484695700000007358642732351268514_",
    style: {
      opacity: 0.1
    },
    points: "424.798,116.379  397.388,100.536 397.388,76.281 396.81,75.948 396.81,67.868 424.798,84.027  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000096058886561019942940000012831202015349523876_",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    points: " 424.798,116.379 397.388,100.536 397.388,76.281 396.81,75.948 396.81,67.868 424.798,84.027  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000151515150373428161460000017863036105105656468_",
    style: {
      opacity: 0.15
    },
    points: "424.797,92.107  414.304,86.048 397.388,76.281 397.388,77.443 424.797,93.266  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000169551191028471495500000000509085504470646187_",
    style: {
      fill: "#BA68C8"
    },
    points: "424.798,116.379  452.058,100.652 452.058,76.366 452.786,75.948 452.786,67.868 424.798,84.027  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000078028779684219454550000014662477922936919471_",
    style: {
      opacity: 0.45,
      fill: "#FFFFFF"
    },
    points: " 424.798,116.379 452.058,100.652 452.058,76.366 452.786,75.948 452.786,67.868 424.798,84.027  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000116953975101444322690000005102010741787012002_",
    style: {
      opacity: 0.1
    },
    points: "452.061,76.366  424.797,92.107 424.797,93.266 452.061,77.541  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000164479387752635707120000013614953563382690472_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000070796922522115065760000003635803589072204423_",
    style: {
      fill: "#BA68C8"
    },
    points: "452.786,67.868  424.798,51.709 396.81,67.868 424.798,84.027  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000139974327555883105160000014179554123795587456_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    points: " 452.786,67.868 424.798,51.709 396.81,67.868 424.798,84.027  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "436.164,109.821 436.164,77.464 440.711,74.839 440.711,107.198  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.15
    },
    points: "436.164,109.821 436.164,77.464 440.711,74.839 440.711,107.198  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "413.431,109.821 413.431,77.464 408.885,74.839 408.885,107.198  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4
    },
    points: "413.431,109.821 413.431,77.464 408.885,74.839 408.885,107.198  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "440.711,74.839 412.723,58.681 408.177,61.306 436.164,77.464  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.25
    },
    points: "425.17,71.117 429.717,68.492 425.17,65.867 420.624,68.492  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "413.431,77.464 441.419,61.305 436.872,58.68 408.885,74.839  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "424.832,70.813 426.884,82.822 426.884,100.028 431.338,94.762 431.338,80.251  425.786,68.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1
    },
    points: "424.832,70.813 426.884,82.822 426.884,100.028 431.338,94.762 431.338,80.251  425.786,68.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "425.926,69.781 443.704,70.894 446.905,66.853 425.94,68.072  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1
    },
    points: "425.926,69.781 443.704,70.894 446.905,66.853 425.94,68.072  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M403.267,59.863c0,0-0.276,3.894,3.969,6.729c6.813,4.549,14.854,4.438,17.596,4.222 l-0.035-2.461c0,0-6.365-0.706-10.468-4.603c-3.694-3.508-4.286-11.686-4.286-11.686L403.267,59.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M403.267,59.863c0,0-0.276,3.894,3.969,6.729c6.813,4.549,14.854,4.438,17.596,4.222 l-0.035-2.461c0,0-6.365-0.706-10.468-4.603c-3.694-3.508-4.286-11.686-4.286-11.686L403.267,59.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M424.832,68.658c0,0-0.532-6.521-5.592-11.289c-5.061-4.768-9.197-5.305-9.197-5.305 c-3.309,2.038-5.643,4.597-6.776,7.799c0,0,4.285-0.973,11.231,2.033c6.179,2.674,10.334,8.918,10.334,8.918V68.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15
    },
    d: "M424.832,68.658c0,0-0.532-6.521-5.592-11.289c-5.061-4.768-9.197-5.305-9.197-5.305 c-3.309,2.038-5.643,4.597-6.776,7.799c0,0,4.285-0.973,11.231,2.033c6.179,2.674,10.334,8.918,10.334,8.918V68.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M409.128,60.175c1.543,0.321,3.324,0.835,5.371,1.721c0.588,0.254,1.15,0.548,1.699,0.859 l3.333-5.09c-0.099-0.098-0.188-0.199-0.291-0.296c-1.862-1.754-3.593-2.928-5.045-3.721 C412.877,55.302,410.643,58.201,409.128,60.175z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M443.704,57.792c0,0,0.858,3.808-2.913,7.249c-6.052,5.521-13.216,5.575-15.959,5.773 l-0.335-2.438c0,0,5.384-0.61,8.855-5.079c3.125-4.024,2.482-12.197,2.482-12.197L443.704,57.792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M443.704,57.792c0,0,0.858,3.808-2.913,7.249c-6.052,5.521-13.216,5.575-15.959,5.773 l-0.335-2.438c0,0,5.384-0.61,8.855-5.079c3.125-4.024,2.482-12.197,2.482-12.197L443.704,57.792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M424.508,68.683c0,0-1.257-5.482,3.03-10.957c4.287-5.475,8.295-6.627,8.295-6.627 c3.577,1.518,6.27,3.697,7.871,6.693c0,0-4.383-0.318-10.798,3.698c-5.707,3.572-8.073,9.324-8.073,9.324L424.508,68.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15
    },
    d: "M424.508,68.683c0,0-1.257-5.482,3.03-10.957c4.287-5.475,8.295-6.627,8.295-6.627 c3.577,1.518,6.27,3.697,7.871,6.693c0,0-4.383-0.318-10.798,3.698c-5.707,3.572-8.073,9.324-8.073,9.324L424.508,68.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M428.984,56.035c2.004,1.015,4.924,2.522,7.194,3.698c2.727-1.261,4.858-1.722,6.143-1.866 c-1.33-1.583-4.204-4.605-7.828-6.189C433.232,52.32,431.218,53.61,428.984,56.035z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "431.338,80.251 426.884,82.822 426.884,100.028 431.338,94.762  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.15
    },
    points: "431.338,80.251 426.884,82.822 426.884,100.028 431.338,94.762  "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Friend_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Friend_00000023972454755001462710000004412323348413453189_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M454.866,245.202l-72.031-41.692c-1.125-0.65-2.599-0.974-4.073-0.974 c-1.474,0-2.948,0.325-4.073,0.974l-0.89,0.538c-2.25,1.299-4.073,4.458-4.073,7.055l-0.001,76.295 c0,2.598,0.034,4.693,3.693,6.779l7.979,4.625c-1.156,3.648-4.371,6.857-7.329,8.273c-0.887,0.425-0.724,1.76,0.242,1.95 c5.196,1.019,11.9,0.016,16.988-4.485l54.531,31.606c1.125,0.65,2.599,0.974,4.074,0.974s2.949-0.325,4.073-0.974l0.89-0.538 c2.249-1.299,4.074-4.458,4.074-7.056v-76.295C458.94,249.659,457.116,246.501,454.866,245.202z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1593_",
    style: {
      fill: "#BA68C8"
    },
    d: "M369.859,209.946c0.475-1.729,2.052-2.28,3.934-1.197l72.039,41.699 c1.121,0.646,2.147,1.748,2.869,3.04l9.032-5.236c-0.741-1.292-1.748-2.394-2.869-3.04l-72.02-41.699 c-2.262-1.292-5.91-1.292-8.152,0l-0.899,0.542C371.873,205.157,370.258,207.628,369.859,209.946z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1592_",
    style: {
      opacity: 0.45,
      fill: "#FFFFFF"
    },
    d: "M369.859,209.946c0.475-1.729,2.052-2.28,3.934-1.197l72.039,41.699 c1.121,0.646,2.147,1.748,2.869,3.04l9.032-5.236c-0.741-1.292-1.748-2.394-2.869-3.04l-72.02-41.699 c-2.262-1.292-5.91-1.292-8.152,0l-0.899,0.542C371.873,205.157,370.258,207.628,369.859,209.946z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1591_",
    style: {
      fill: "#BA68C8"
    },
    d: "M458.939,328.552c0,2.598-1.824,5.757-4.073,7.056l-0.89,0.538 c-2.033,1.174-5.198,1.29-7.451,0.342c1.917,0.725,3.377-0.37,3.377-2.693l0-76.295c0-1.299-0.456-2.738-1.193-4.014l9.036-5.241 c0.737,1.277,1.193,2.715,1.193,4.014V328.552z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1590_",
    style: {
      opacity: 0.25,
      fill: "#FFFFFF"
    },
    d: "M458.939,328.552c0,2.598-1.824,5.757-4.073,7.056l-0.89,0.538 c-2.033,1.174-5.198,1.29-7.451,0.342c1.917,0.725,3.377-0.37,3.377-2.693l0-76.295c0-1.299-0.456-2.738-1.193-4.014l9.036-5.241 c0.737,1.277,1.193,2.715,1.193,4.014V328.552z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Character_15_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M392.202,305.065l-0.9-0.52c-0.24,0.22-0.49,0.42-0.74,0.62c-0.52,0.42-1.05,0.79-1.6,1.14 c-0.25,0.16-0.5,0.31-0.75,0.45c-0.27,0.16-0.54,0.3-0.81,0.44c-0.01,0.01-0.02,0.01-0.03,0.02c-0.26,0.13-0.53,0.26-0.79,0.38 c-0.22,0.1-0.44,0.2-0.67,0.29c-0.21,0.08-0.42,0.16-0.62,0.23c-0.94,0.36-1.91,0.63-2.87,0.83c-0.24,0.05-0.48,0.1-0.71,0.14 c-0.24,0.04-0.48,0.08-0.72,0.11c-0.19,0.03-0.37,0.05-0.56,0.07c-0.05,0.01-0.1,0.01-0.15,0.02c-2.09,0.21-4.13,0.1-5.97-0.26 c-0.97-0.19-1.13-1.53-0.24-1.95c2.95-1.42,6.17-4.62,7.33-8.27l-0.52-0.3l0.47-0.08c2.74-2.2,5.89-2.8,9.34-3.2 L392.202,305.065z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M432.653,324.825c-0.09,1.01-0.18,2.07-0.28,3.17l-11.23-6.51l-26.92-15.6 c-0.08,0.07-0.17,0.14-0.25,0.21l-1.77-1.03l-0.9-0.52c-3.28,2.9-7.24,4.35-11.02,4.74c0.66-2.14,1.39-3.96,2.14-5.5 c2.759-6.26,7.47-8.41,8.27-8.56c3.22-0.6,10.21-1.12,20.68,0.67c8.12,1.39,19.32,7.41,19.32,7.41 C433.302,305.715,433.603,314.505,432.653,324.825z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M432.653,324.825c-0.09,1.01-0.18,2.07-0.28,3.17l-11.23-6.51l-26.92-15.6 c-0.08,0.07-0.17,0.14-0.25,0.21l-1.77-1.03l-0.9-0.52c-3.28,2.9-7.24,4.35-11.02,4.74c0.66-2.14,1.39-3.96,2.14-5.5 c2.759-6.26,7.47-8.41,8.27-8.56c3.22-0.6,10.21-1.12,20.68,0.67c8.12,1.39,19.32,7.41,19.32,7.41 C433.302,305.715,433.603,314.505,432.653,324.825z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5362_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5610_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M389.178,262.92c-1.36-1.197-2.518-2.542-3.06-4.681c-0.583-2.3-0.725-4.123-0.396-6.54 c0.074-0.542,0.422-1.775,0.708-2.229c0.525-0.835,1.516-1.049,2.398-1.163c0.564-0.073,1.128-0.136,1.692-0.189 c-0.925-1.179-1.875-2.405-2.283-3.931c-0.302-1.129-0.284-2.382,0.05-3.536c0.091-0.313,0.211-0.63,0.426-0.856 c0.5-0.527,1.278-0.415,1.908-0.207c5.083,1.675,10.129,1.39,11.898,1.333c3.189-0.102,4.807-0.472,9.199-0.79 c4.392-0.318,12.033,2.048,12.78,10.963c5.771,1.201,5.838,11.4,3.876,15.645c-3.613,7.818-6.906,12.965-8.845,18.615 c-0.287-0.24-19.051-13.009-23.308-16.569c-1.595-1.334-3.191-2.668-4.786-4.002 C390.667,264.14,389.895,263.551,389.178,262.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M425.608,279.665c-3.666,2.716-5.753-0.032-5.753-0.032l-1.165,19.179 c-7.868,9.941-27.057,7.854-18.053-2.161l0.118-4.596c0,0-2.93,0.112-5.32-0.378c-1.045-0.215-2.216-0.726-3.021-1.32 c-1.899-1.385-3.193-3.217-3.853-6.254c-0.78-3.621-1.074-8.444-0.755-13.779c0.333-5.572,1.314-12.756,3.257-16.452 c3.276-2.868,12.493-2.943,20.079-0.376c0.007,2.089-0.305,3.906,1.094,6.229c0.687,1.141,1.828,2.023,2.798,2.576 c-0.051,4.055,0.031,5.151,0.614,6.954c0.321,1.038,0.99,2.598,2.946,1.895c0.923-0.332,1.728-2.468,2.749-3.876 c1.374-1.895,5.369-2.707,7.014,1.502C430.016,273.062,428.111,277.79,425.608,279.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M400.758,292.05c3.933-0.331,10.995-1.765,13.172-4.293c2.177-2.527,4.116-8.431,4.116-8.431 s-1.199,6.654-2.907,9.52c-1.709,2.865-5.162,3.956-7.676,4.71c-2.514,0.754-6.773,1.051-6.773,1.051L400.758,292.05z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5561_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5609_",
    style: {
      fill: "#263238"
    },
    d: "M404.648,263.386l3.626,1.837c0.5-1.144,0.094-2.484-0.908-2.991 C406.365,261.725,405.148,262.241,404.648,263.386z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5608_",
    style: {
      fill: "#263238"
    },
    d: "M394.37,262.23l-4.036,1.236c-0.218-1.189,0.51-2.43,1.624-2.771 C393.073,260.354,394.152,261.041,394.37,262.23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5607_",
    style: {
      fill: "#B16668"
    },
    d: "M405.488,278.213l-6.953,2.645c0.661,2.06,2.755,3.138,4.675,2.407 C405.13,282.534,406.15,280.272,405.488,278.213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M405.182,279.736c-1.941-0.043-3.618,1.605-3.777,3.69c0.587,0.101,1.203,0.068,1.805-0.161 c1.43-0.544,2.358-1.938,2.466-3.464C405.514,279.772,405.352,279.739,405.182,279.736z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5606_",
    style: {
      fill: "#F28F8F"
    },
    points: "399.921,264.023 397.863,277.17 391.722,274.161  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M406.974,268.098c-0.052,1.061-0.892,1.917-1.876,1.911c-0.985-0.006-1.741-0.87-1.689-1.932 c0.052-1.061,0.892-1.917,1.876-1.911C406.27,266.172,407.026,267.036,406.974,268.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M394.609,266.81c-0.048,0.994-0.835,1.795-1.756,1.789c-0.922-0.005-1.63-0.815-1.582-1.809 c0.048-0.994,0.835-1.795,1.757-1.79C393.949,265.006,394.658,265.816,394.609,266.81z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M443.13,334.225l-10.76-6.23l-11.23-6.51c0-0.16,0.01-0.33,0.02-0.49 c0.56-10.9,9.53-17.69,9.53-17.69c4.16,2.18,9.22,6.36,11.11,11.76C443.67,320.415,443.16,322.645,443.13,334.225z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M371.969,209.484c0.232,0,0.623,0.067,1.171,0.386l72.046,41.689 c0.903,0.52,1.774,1.45,2.393,2.554c0.66,1.141,1.033,2.367,1.033,3.378V333.8c0,0.603-0.126,1.613-0.969,1.613 c-0.144,0-0.304-0.025-0.475-0.074l-0.084-0.024l-0.021-0.003l-0.051-0.018c-0.192-0.084-0.372-0.168-0.541-0.264l-31.746-18.391 l-13.572-7.876l-9.206-5.339l-0.804-0.466l-0.696,0.616c-3.298,2.919-7.67,4.526-12.308,4.526c-0.963,0-1.915-0.071-2.838-0.211 c2.864-1.592,6.083-4.764,7.329-8.702l0.312-0.985l-0.894-0.518l-7.979-4.627c-3.058-1.735-3.058-3.211-3.058-5.657v-76.293 c0-0.257,0.025-0.531,0.074-0.814l0.018,0.004C371.322,209.484,371.792,209.484,371.969,209.484 M371.97,208.195 C371.969,208.195,371.969,208.195,371.97,208.195c-1.023,0-1.802,0.628-2.112,1.758c0.046-0.292,0.123-0.583,0.199-0.875 c-0.215,0.676-0.337,1.366-0.337,2.027v76.293c0,2.595,0.046,4.698,3.7,6.771l7.979,4.628c-1.155,3.65-4.371,6.861-7.33,8.277 c-0.887,0.425-0.724,1.76,0.242,1.949c1.207,0.237,2.495,0.364,3.826,0.364c4.397,0,9.257-1.393,13.162-4.849l9.206,5.339 l13.573,7.877l31.753,18.395c0.215,0.123,0.445,0.23,0.691,0.338c0.092,0.031,0.185,0.077,0.292,0.092 c0.29,0.082,0.567,0.123,0.828,0.123c1.343,0,2.258-1.064,2.258-2.902v-76.309c0-1.29-0.46-2.733-1.197-4.008 c-0.722-1.29-1.751-2.395-2.872-3.04l-72.044-41.688C373.135,208.376,372.518,208.195,371.97,208.195L371.97,208.195z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Friend_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Friend_00000151544939924326829990000013144249278587154565_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M126.776,222.163c0-2.158-1.515-4.782-3.384-5.862l-0.74-0.447c-0.935-0.54-2.159-0.81-3.384-0.81 s-2.45,0.27-3.384,0.81l-59.851,34.642c-1.869,1.079-3.385,3.703-3.385,5.862v63.394c0,2.159,1.516,4.783,3.385,5.862l0.74,0.447 c0.935,0.54,2.16,0.809,3.384,0.809c1.225,0,2.45-0.27,3.385-0.809l45.31-26.261c4.227,3.74,9.798,4.573,14.115,3.726 c0.803-0.157,0.939-1.267,0.201-1.62c-2.458-1.176-5.129-3.842-6.09-6.874l6.63-3.843c3.041-1.734,3.069-3.474,3.069-5.633 L126.776,222.163z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000005959647347763393850000008702477605267429048_",
    style: {
      fill: "#BA68C8"
    },
    d: "M126.666,221.202 c-0.395-1.437-1.705-1.895-3.269-0.995l-59.858,34.648c-0.931,0.537-1.784,1.453-2.384,2.526l-7.505-4.351 c0.616-1.074,1.453-1.99,2.384-2.526l59.842-34.648c1.879-1.074,4.91-1.074,6.774,0l0.747,0.451 C124.992,217.223,126.334,219.275,126.666,221.202z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000160891150818202196780000016296263821436400303_",
    style: {
      opacity: 0.45,
      fill: "#FFFFFF"
    },
    d: "M126.666,221.202 c-0.395-1.437-1.705-1.895-3.269-0.995l-59.858,34.648c-0.931,0.537-1.784,1.453-2.384,2.526l-7.505-4.351 c0.616-1.074,1.453-1.99,2.384-2.526l59.842-34.648c1.879-1.074,4.91-1.074,6.774,0l0.747,0.451 C124.992,217.223,126.334,219.275,126.666,221.202z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000050646137487573300160000016704288038827424656_",
    style: {
      fill: "#BA68C8"
    },
    d: "M52.648,319.752 c0,2.159,1.516,4.783,3.385,5.863l0.74,0.447c1.689,0.975,4.319,1.072,6.191,0.284c-1.593,0.602-2.806-0.307-2.806-2.238l0-63.394 c0-1.079,0.379-2.275,0.991-3.336l-7.508-4.355c-0.612,1.061-0.991,2.256-0.991,3.336V319.752z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000016046950496282634340000009024223076767607434_",
    style: {
      opacity: 0.25,
      fill: "#FFFFFF"
    },
    d: "M52.648,319.752 c0,2.159,1.516,4.783,3.385,5.863l0.74,0.447c1.689,0.975,4.319,1.072,6.191,0.284c-1.593,0.602-2.806-0.307-2.806-2.238l0-63.394 c0-1.079,0.379-2.275,0.991-3.336l-7.508-4.355c-0.612,1.061-0.991,2.256-0.991,3.336V319.752z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Chest_5_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M122.969,303.525c-1.12,0.22-2.33,0.33-3.57,0.29c-2.95-0.06-6.13-0.88-8.92-2.75l-2.17-11.66 c4.93-0.05,8.22,0.47,10.64,1.94c0.74,0.45,1.39,0.93,1.99,1.46l-3.86,2.23c0.96,3.03,3.63,5.7,6.09,6.87 C123.909,302.255,123.769,303.365,122.969,303.525z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Chest_00000103952894196559509240000013299919225619731643_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M119.399,303.815c-2.95-0.06-6.13-0.88-8.92-2.75c-0.56-0.38-1.11-0.8-1.63-1.26l-31.41,18.21 l-6.89,3.99c-0.2-0.98-0.4-1.97-0.62-3c-1.56-7.42,0.4-18.95,3.69-20.55c4.29-2.09,5.36-2.74,6.6-3.68c0,0,5.99-5.64,15.92-5.51 c3.9,0.05,7.8-0.04,12.17,0.14C112.849,289.595,116.999,294.445,119.399,303.815z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head_00000139252784608957147410000010660404440926382261_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5636_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5699_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M80.528,253.585c-4.26,5.502-2.229,10.669-0.312,17.151c2.225,7.377,3.735,11.01,5.401,11.495 c-1.931-23.176,6.742,5.16,23.17-12.885c2.97-3.262,2.713-13.343-1.273-17.911C101.88,244.979,88.876,243.208,80.528,253.585 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B16668"
    },
    d: "M79.897,278.195c2.463,1.701,4.524-0.927,4.524-0.927l1.23,15.368c0,0,0.02,1.954,4.255,4.383 c2.801,1.607,8.613,2.53,11.923,6.022c1.391-2.525,2.51-7.201-0.594-11.177l-0.249-4.168c0,0,1.598,0.202,3.328-0.296 c2.265-0.653,5.231-2.983,6.016-6.449c1.258-5.574,0.65-13.979-1.692-24.867c-3.43-2.838-15.413-2.798-20.856,2.155 c1.872,6.583-1.314,8.104-1.23,10.428c-0.422,0.913-1.009,1.673-1.363,2.011c-1.061,1.006-2.034-1.647-2.982-2.695 c-0.957-1.04-3.997-2.487-5.377,0.887C75.435,272.305,77.769,276.732,79.897,278.195z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5639_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5642_",
    style: {
      fill: "#263238"
    },
    d: "M95.13,263.012l-2.837,1.911c-0.526-0.905-0.317-2.067,0.466-2.595 C93.543,261.801,94.604,262.107,95.13,263.012z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5641_",
    style: {
      fill: "#263238"
    },
    d: "M108.123,263.133l-3.435-1.052c0.172-0.988,1.081-1.553,2.029-1.262 C107.665,261.109,108.295,262.145,108.123,263.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M93.922,267.354c0.053,0.838,0.725,1.502,1.502,1.485c0.776-0.018,1.363-0.711,1.31-1.548 c-0.053-0.838-0.726-1.502-1.502-1.484C94.456,265.823,93.869,266.516,93.922,267.354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M105.013,266.299c0.053,0.838,0.725,1.502,1.502,1.484c0.777-0.018,1.363-0.711,1.31-1.548 c-0.053-0.838-0.725-1.502-1.502-1.485C105.547,264.768,104.961,265.461,105.013,266.299z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5640_",
    style: {
      fill: "#9A4A4D"
    },
    d: "M99.571,263.007l1.024,9.315l4.951-1.828 C104.709,267.91,101.586,264.046,99.571,263.007z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M86.494,267.822c0.298,6.321,3.025,7.529,5.265,8.191c3.571,1.056,5.207-2.157,9.347-2.47 c2.371-0.179,2.986,0.283,5.226,1.701c0.338,0.214,1.276,0.694,1.69,0.778c0.844,0.172,2.138,0.289,2.491-0.964 c0.454-1.609,0.404-4.935,0.029-7.699l-0.145-1.511c0,0,1.242,6.649,0.773,11.827c-0.294,3.245-1.364,6.273-2.958,7.815 c-2.186,2.114-6.1,3.321-12.198,2.135c-6.009-1.168-8.48-3.243-9.378-5.497c-2.915-7.312-2.27-10.852-3.165-12.221 C82.579,268.539,86.494,267.822,86.494,267.822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B16668"
    },
    d: "M102.624,275.423c2.827,0.27,4.279,1.44,4.403,3.405c0.124,1.965-0.335,4.399-1.957,5.134 c-1.622,0.735-1.538-1.177-1.332-2.21c0.207-1.033-0.357-0.8-1.275-0.779c-0.918,0.021-1.296-0.115-0.943,0.923 c0.352,1.038,0.855,2.501-1.047,2.321c-1.902-0.18-3.359-2.136-3.804-4.624C96.224,277.105,98.35,275.014,102.624,275.423z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5701_",
    style: {
      fill: "#9A4A4D"
    },
    d: "M98.801,277.029l4.805-0.008c-0.086,1.326-1.04,2.395-2.367,2.397 C99.913,279.42,98.722,278.362,98.801,277.029z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M98.879,277.684c0.268,1.007,1.262,1.736,2.36,1.734c0.502-0.001,0.951-0.156,1.319-0.418 C101.589,278.107,100.284,277.602,98.879,277.684z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head_4_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M101.829,303.041c-1.829-1.14-6.647-3.306-7.034-2.024c-0.272,0.902-1.053,4.182-2.41,4.108 c-1.806-0.099-6.695-1.927-9.941-5.962c-2.078-2.583-2.228-4.388-2.228-4.388s1.606-3.456,2.596-5.042 c0.983-1.574,1.249-2.586,2.363-2.687l0.297,3.247c0,0,1.089,2.108,3.32,3.72C92.049,296.365,98.54,298.922,101.829,303.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M101.829,303.041c0.991-1.049,2.636-5.36,3.49-5.192c1.779,0.35,2.998,1.713,2.993,0.721 c-0.005-0.992-1.326-3.098-2.933-5.97c-1.233-2.203-3.193-4.017-4.352-4.214l0.275,4.451c0,0,0.679,1.369,0.931,3.819 C102.502,299.28,102.509,301.214,101.829,303.041z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M77.579,316.695l-14.57,8.44c-0.14,0.08-0.29,0.15-0.45,0.22l-0.04,0.02h-0.02l-0.07,0.02 c-0.14,0.04-0.27,0.06-0.39,0.06c-0.71,0-0.81-0.84-0.81-1.34v-12.76c0.02-0.09,0.04-0.19,0.06-0.28 c1.1-5.05,7.07-10.21,12.33-12.62C77.819,303.685,78.079,311.354,77.579,316.695z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M124.912,220.818c0.147,0,0.537,0,0.722,0.674l0.015-0.003c0.041,0.235,0.062,0.463,0.062,0.677 v63.393c0,2.032,0,3.259-2.541,4.7l-6.63,3.845l-0.743,0.431l0.259,0.819c1.035,3.272,3.71,5.908,6.09,7.23 c-0.767,0.117-1.558,0.176-2.358,0.176c-3.854,0-7.486-1.336-10.227-3.761l-0.579-0.512l-0.668,0.388l-7.65,4.436l-11.277,6.545 l-26.378,15.281c-0.14,0.08-0.29,0.149-0.449,0.219l-0.042,0.015l-0.017,0.003l-0.07,0.02c-0.143,0.04-0.276,0.061-0.395,0.061 c-0.701,0-0.806-0.84-0.806-1.34v-63.405c0-0.84,0.31-1.859,0.859-2.807c0.514-0.917,1.237-1.69,1.988-2.122l59.864-34.64 C124.395,220.873,124.72,220.818,124.912,220.818 M124.912,219.747c-0.455,0-0.968,0.15-1.511,0.466l-59.862,34.639 c-0.931,0.536-1.786,1.454-2.386,2.526c-0.612,1.059-0.995,2.258-0.995,3.33v63.405c0,1.527,0.76,2.411,1.876,2.411 c0.217,0,0.447-0.034,0.688-0.102c0.089-0.013,0.166-0.051,0.243-0.076c0.204-0.089,0.395-0.179,0.574-0.281l26.384-15.284 l11.278-6.545l7.649-4.436c3.245,2.871,7.283,4.029,10.937,4.029c1.106,0,2.176-0.106,3.179-0.303 c0.803-0.157,0.938-1.267,0.201-1.62c-2.459-1.177-5.131-3.845-6.091-6.878l6.63-3.845c3.037-1.722,3.075-3.47,3.075-5.626 v-63.393c0-0.549-0.102-1.123-0.28-1.684c0.063,0.242,0.127,0.485,0.166,0.727C126.409,220.269,125.762,219.747,124.912,219.747 C124.912,219.747,124.912,219.747,124.912,219.747L124.912,219.747z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Friend_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Friend_00000004536360626216566930000000661026889286382505_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M122.951,52.182c0-2.617-1.837-5.799-4.104-7.108l-0.897-0.542 c-1.133-0.654-2.618-0.982-4.104-0.982c-1.486,0-2.971,0.327-4.104,0.982L37.172,86.538c-2.267,1.309-4.104,4.49-4.104,7.108 v76.868c0,2.617,1.838,5.8,4.104,7.108l0.896,0.542c1.133,0.654,2.619,0.982,4.104,0.982c1.486,0,2.971-0.327,4.104-0.982 l54.941-31.843c5.126,4.535,11.881,5.545,17.115,4.518c0.973-0.191,1.138-1.536,0.244-1.964c-2.981-1.426-6.22-4.659-7.384-8.335 l8.039-4.659c3.687-2.102,3.721-4.212,3.721-6.83L122.951,52.182z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000019678985720618999180000001483473605112244902_",
    style: {
      fill: "#BA68C8"
    },
    d: "M122.818,51.017 c-0.479-1.742-2.067-2.298-3.963-1.206L46.274,91.823c-1.129,0.651-2.163,1.761-2.891,3.063l-9.1-5.276 c0.747-1.302,1.761-2.412,2.891-3.063l72.562-42.012c2.279-1.302,5.954-1.302,8.214,0l0.906,0.547 C120.788,46.192,122.415,48.681,122.818,51.017z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000115475949761224743120000006936752787548208547_",
    style: {
      opacity: 0.45,
      fill: "#FFFFFF"
    },
    d: "M122.818,51.017 c-0.479-1.742-2.067-2.298-3.963-1.206L46.274,91.823c-1.129,0.651-2.163,1.761-2.891,3.063l-9.1-5.276 c0.747-1.302,1.761-2.412,2.891-3.063l72.562-42.012c2.279-1.302,5.954-1.302,8.214,0l0.906,0.547 C120.788,46.192,122.415,48.681,122.818,51.017z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000013890073629644926770000000911180254207839106_",
    style: {
      fill: "#BA68C8"
    },
    d: "M33.068,170.514 c0,2.618,1.838,5.8,4.104,7.109l0.897,0.542c2.049,1.183,5.237,1.299,7.507,0.344c-1.931,0.73-3.402-0.373-3.402-2.714l0-76.868 c0-1.309,0.46-2.759,1.202-4.045l-9.104-5.281c-0.743,1.286-1.202,2.736-1.202,4.045V170.514z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000063617317504258693000000014120107025780300689_",
    style: {
      opacity: 0.25,
      fill: "#FFFFFF"
    },
    d: "M33.068,170.514 c0,2.618,1.838,5.8,4.104,7.109l0.897,0.542c2.049,1.183,5.237,1.299,7.507,0.344c-1.931,0.73-3.402-0.373-3.402-2.714l0-76.868 c0-1.309,0.46-2.759,1.202-4.045l-9.104-5.281c-0.743,1.286-1.202,2.736-1.202,4.045V170.514z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Top_00000051369398030076026850000009650989207827671171_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arm_15_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0997A"
    },
    d: "M118.869,149.095l-1.673,1.928c-0.752,0.109-1.516,0.17-2.316,0.17 c-3.201,0.073-6.681-0.594-9.87-2.267l-5.808-15.314c6.342-0.194,9.725,0.048,14.138,4.329c0.243,0.23,0.534,0.521,0.861,0.861 l-3.007,1.746c1.164,3.674,4.401,6.899,7.385,8.33C118.699,148.937,118.796,149.01,118.869,149.095z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Chest_14_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M114.88,151.192c-3.201,0.073-6.681-0.594-9.87-2.267c-1.322-0.691-2.607-1.552-3.795-2.607 l-26.615,15.424l-3.844,2.231c0.255-0.994,0.449-2.11,0.57-3.371c1.104-11.701-3.589-17.594-4.11-18.225 c-0.012-0.012-0.024-0.024-0.037-0.036l-0.012-0.012c0,0,3.856-2.255,8.864-4.195c5.008-1.94,7.809-2.934,17.242-4.329 l5.929-0.194c0,0,6.499,4.838,11.41,10.295C111.363,144.729,113.91,147.688,114.88,151.192z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head_6_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    style: {
      fill: "#37474F"
    },
    d: "M108.159,131.061c1.313-9.854-10.168-8.942-13.519-15.248l8.718-6.776 c5.373-3.671,4.295-11.685,2.499-15.782c-4.009-9.147-13.699-12.049-19.515-12.021c-11.029,0.052-16.083,3.454-16.61,9.665 c-4.081-0.099-9.794,4.692-9.188,17.978c0.121,2.656,0.423,5.886-0.786,8.186c-1.063,2.022-2.67,3.988-3.349,6.268 c-1.128,3.79,0.273,9.242,4.689,9.81c-0.37-0.994-0.953-2.312-0.204-3.265c0.521,4.691,8.187,7.335,11.608,6.057 c-0.933-0.6-1.668-1.105-2.036-2.277c5.797,2.967,10.569,1.569,16.165-0.85c1.008-0.436,1.691-0.636,5.02,0.222 c2.023,0.521,4.45,0.748,8.144-1.482C102.123,130.14,105.757,128.043,108.159,131.061z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5729_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5744_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5745_",
    style: {
      fill: "#FFBDA7"
    },
    d: "M72.908,120.478c-1.955,0.442-3.9-0.575-5.19-1.976 c-2.863-3.109-3.31-6.326-2.2-8.498c0.912-1.785,3.361-2.965,5.2-1.809c1.966,1.236,2.09,2.276,2.893,3.702 c0.824,1.464,3.553,1.241,3.85-4.588c0.278-5.437,0.734-10.425,3.043-12.926c3.447-3.735,7.81-2.216,9.41-0.089 c1.342-2.561,3.924-3.594,6.526-2.195c2.551,1.371,4.166,4.348,5.67,14.62c1.533,10.471-0.034,17.949-2.153,19.761 c-1.608,1.375-3.738,1.706-7.376,1.962l0.295,6.933c0,0,3.968,2.593,4.514,11.585c-6.354-1.378-16.151-3.474-21.561-8.355 l-0.938-19.82C74.892,118.785,74.766,120.057,72.908,120.478z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5742_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5743_",
    style: {
      fill: "#263238"
    },
    d: "M87.285,107.958c-0.212,0.955-1.084,1.513-1.947,1.248 c-0.864-0.266-1.392-1.255-1.18-2.21c0.212-0.955,1.084-1.514,1.948-1.248C86.969,106.014,87.497,107.003,87.285,107.958z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M85.523,105.691c-1.005,0.051-1.51,1.526-2.514,0.966c0.209,0.781,1.324,1.228,2.011,0.818 C85.458,107.213,85.523,105.691,85.523,105.691z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5740_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5741_",
    style: {
      fill: "#263238"
    },
    d: "M99.494,102.768l-3.536-1.807c0.384-1.056,1.488-1.507,2.464-1.008 C99.399,100.451,99.879,101.712,99.494,102.768z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5738_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5739_",
    style: {
      fill: "#263238"
    },
    d: "M95.772,107.221c0.373,0.927,1.334,1.395,2.145,1.047 c0.811-0.348,1.166-1.381,0.792-2.307c-0.374-0.926-1.334-1.395-2.145-1.047C95.753,105.263,95.398,106.296,95.772,107.221z "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M97.131,104.8c1.006-0.048,1.758,1.365,2.658,0.711c-0.073,0.795-1.103,1.347-1.854,1.008 C97.455,106.303,97.131,104.8,97.131,104.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5736_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5737_",
    style: {
      fill: "#263238"
    },
    d: "M85.584,101.77l-3.336,2.424c-0.706-1.007-0.532-2.366,0.39-3.036 C83.559,100.49,84.879,100.763,85.584,101.77z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5734_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5735_",
    style: {
      fill: "#B16668"
    },
    d: "M86.618,116.665l5.455,1.509c-0.262,1.632-1.849,2.608-3.564,2.063 C87.016,119.761,86.356,118.296,86.618,116.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0997A"
    },
    d: "M90.047,120.312c-0.322-1.578-1.685-2.73-3.194-2.615c-0.092,0.007-0.176,0.034-0.265,0.05 c0.12,1.166,0.769,2.123,1.921,2.489C89.049,120.408,89.57,120.415,90.047,120.312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5732_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5733_",
    style: {
      fill: "#F0997A"
    },
    points: "90.299,104.157 92.03,114.437 97.082,112.175  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5730_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5731_",
    style: {
      fill: "#F0997A"
    },
    d: "M92.58,128.442c-3.4-0.164-6.993-0.473-10.513-1.851 c-1.245-0.487-3.067-2.754-4.616-5.304c0,0,1.384,5.111,4.128,6.75c4.173,2.493,11.101,2.759,11.101,2.759L92.58,128.442z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M76.315,120.838c0.249,1.969-0.669,3.787-2.173,4.664c-0.495,0.299-1.036,0.483-1.643,0.535 c-2.444,0.228-4.688-1.712-5.015-4.358c-0.129-1.043,0.049-2.063,0.494-2.922c0.139,0.148,0.276,0.277,0.412,0.386 c0.273,0.238,0.559,0.417,0.824,0.558c-0.274,0.559-0.38,1.186-0.303,1.843c0.231,1.776,1.753,3.094,3.393,2.928 c0.659-0.074,1.228-0.357,1.673-0.809c0.661-0.657,1.024-1.629,0.893-2.691c-0.231-1.776-1.753-3.094-3.375-2.93 c-0.41,0.041-0.781-0.289-0.82-0.714c-0.056-0.424,0.215-0.808,0.608-0.849C73.727,116.254,75.97,118.194,76.315,120.838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M76.315,120.838c0.249,1.969-0.669,3.787-2.173,4.664c-0.495,0.299-1.036,0.483-1.643,0.535 c-2.444,0.228-4.688-1.712-5.015-4.358c-0.129-1.043,0.049-2.063,0.494-2.922c0.139,0.148,0.276,0.277,0.412,0.386 c0.273,0.238,0.559,0.417,0.824,0.558c-0.274,0.559-0.38,1.186-0.303,1.843c0.231,1.776,1.753,3.094,3.393,2.928 c0.659-0.074,1.228-0.357,1.673-0.809c0.661-0.657,1.024-1.629,0.893-2.691c-0.231-1.776-1.753-3.094-3.375-2.93 c-0.41,0.041-0.781-0.289-0.82-0.714c-0.056-0.424,0.215-0.808,0.608-0.849C73.727,116.254,75.97,118.194,76.315,120.838z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Arm_7_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBDA7"
    },
    d: "M74.599,161.742l-3.844,2.231l-13.786,7.991c-0.036-1.382-0.085-2.765-0.133-4.098 c-0.691-18.031,2.025-20.395,10.331-25.536l0.012,0.012c0.012,0.012,0.024,0.024,0.037,0.036 C73.131,147.906,74.392,156.807,74.599,161.742z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M120.692,50.551c0.178,0,0.651,0,0.875,0.817l0.018-0.004c0.05,0.285,0.075,0.562,0.075,0.821 v76.867c0,2.464,0,3.951-3.081,5.699l-8.039,4.662l-0.901,0.522l0.314,0.993c1.255,3.967,4.498,7.163,7.384,8.767 c-0.93,0.142-1.889,0.213-2.859,0.213c-4.674,0-9.078-1.619-12.401-4.56l-0.702-0.621l-0.81,0.47l-9.276,5.379l-13.674,7.936 L45.63,177.041c-0.17,0.097-0.352,0.181-0.545,0.266l-0.052,0.019l-0.021,0.003l-0.084,0.024 c-0.173,0.049-0.334,0.074-0.479,0.074c-0.85,0-0.977-1.018-0.977-1.625V98.919c0-1.019,0.376-2.254,1.041-3.404 c0.623-1.112,1.5-2.05,2.41-2.574l72.588-42.003C120.064,50.619,120.458,50.551,120.692,50.551 M120.691,49.253 c-0.552,0-1.174,0.182-1.832,0.565L46.274,91.819c-1.129,0.65-2.166,1.764-2.893,3.063c-0.743,1.284-1.206,2.738-1.206,4.038 v76.882c0,1.852,0.922,2.924,2.275,2.924c0.263,0,0.542-0.041,0.834-0.124c0.108-0.015,0.201-0.062,0.294-0.093 c0.247-0.108,0.479-0.217,0.696-0.34l31.992-18.533l13.675-7.936l9.275-5.379c3.935,3.482,8.831,4.886,13.261,4.886 c1.341,0,2.639-0.128,3.855-0.367c0.973-0.191,1.138-1.536,0.244-1.964c-2.982-1.427-6.222-4.662-7.385-8.339l8.039-4.662 c3.682-2.089,3.728-4.208,3.728-6.822V52.185c0-0.665-0.123-1.361-0.34-2.042c0.077,0.294,0.155,0.588,0.201,0.882 C122.507,49.886,121.722,49.253,120.691,49.253C120.692,49.253,120.691,49.253,120.691,49.253L120.691,49.253z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferAFriendGraphic);
export default __webpack_public_path__ + "static/media/refer-a-friend-graphic.c97dd9a38f3593dda246b2674c9b7e57.svg";
export { ForwardRef as ReactComponent };